/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { SalesQuotationRo, vRdxUserInfo } from "../../Redux/roStore";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import { confirmAlert } from "react-confirm-alert"; // Import

import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  fAlertToast,
  fCalculate_Detail,
  fKeyTabInput,
  fcovertToNumber,
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
  fCheck_Doc_Rights_001,
  FShortCutKey,
  GetAccountPostingDetail,
  GetLinkDocument,
  DisableApproveFlag,
} from "../../Utility/Utilitys";
import Footer from "./processComponent/Footer";
import { fExecuteAPI } from "../../Server/Apis";
import {
  inv05_SalesQuotation_Save_GETROW,
  inv05_SalesQuotation_Load_GETROW,
  inv05_SalesQuotation_Search_GETROW,
  inv05_SalesQuotation_Display_GETROW,
  inv05_SalesQuotation_Delete_GETROW,
  inv05_SalesQuotation_Discount_GETROW,
  inv05_SalesQuotation_sopstockdetail_GETROW,
  inv05_SalesQuotation_Reverse_GETROW,
  inv05_SalesQuotation_HistoryGrid_GETROW,
  validationINV05_SalesQuotation_GETROW,
  ApproveINV05_SalesQuotation_GETROW,
  SubKonten_Search_Full_V3Api,
} from "../../Server/ApiV2";
import {
  sTrnTyp,
  fRightClick,
  fLeftClick,
  Get_GCSearchBtn,
} from "./SalesQuotationAction";
import {
  Set_SalesQuotation_HeadObject_Set,
  Set_SalesQuotation_HeadObject_New,
  Set_SalesQuotation_HeadObject_VocNo_Doc,
  Set_SalesQuotation_HeadObject_DocStatus,
  Set_SalesQuotation_HeadObject_SalesGroup_SalesMan,
  SalesQuotation_HeadObject_Init,
} from "./SliceSalesQuotation";
import "./SalesQuotation.css";
import GCSearcgSalesQuotation from "./processComponent/GCSalesQuotationSearch";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage";
import GCAudit from "../../Component/Common/ReuseableComponent/GCAudit";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  GetSearchItem,
  sItemSearchData,
  sCustomerSearchData,
  GetSearchCustomer,
  fDefaultPayload,
  GetOSAmount,
  GetAttributes,
  getTransItemStockUOM,
} from "./SalesQuotationAction";

import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function SalesQuotation() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const RefNoFocusOnLoad = useRef(null);
  const ClickNewFocsItem = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const vRdxSalesQuotationHead = useSelector(
    (state) => state.SliceSalesQuotation.value.HeadObject
  );

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxPricelevel = useSelector(
    (state) => state.SliceGRN.value.priceLevel
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const [sDocLoading, setDocLoading] = useState([]); // GrnType Select

  const [sCurrency, setCurrency] = useState([]); //Currency Select
  const [sTaxTaxType, setTaxType] = useState([
    { Uid: "OTTRN001", Name: "VAT" },
    { Uid: "OTTRN002", Name: "Inter.Comp" },
    { Uid: "OTTRN003", Name: "Import" },
  ]); //Currency Select
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sSalesman, setSalesman] = useState([]); //sSalesman Select
  const [sLocation, setLocation] = useState([]); //sSalesman Select
  const [sGCSeachSalesGroupSearch, setGCSeachSalesGroupSearch] = useState([]); //GCSeachSalesGroupSearch Select
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
  const [sToggleGrid, setToggleGrid] = useState(false);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  // const [sOnGridClick, setOnGridClick] = useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API
  const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
  // const [sInstTypeArr, setInstTypegArr] = useState([
  //   "Walk-In",
  //   "Distribution",
  //   "Instant Picking",
  // ]);
  const [sNarrArr, setNarrArr] = useState([]);
  const sPayModeArr = ["CREDIT", "CASH", "CC"];
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const [sOsAmount, setOsAmount] = useState({
    NetOsAmt: 0,
    PDCAmt: 0,
    BalanceOsAmt: 0,
  }); //to set paymode enable or disable

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sBufferObj, setBufferObj] = useState({
    B_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
    B_VocNo: vRdxSalesQuotationHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(2),
    B_URateFc: (0).toFixed(2),
    B_URateLc: (0).toFixed(2),
    B_GrossAmt: (0).toFixed(2),
    B_LDiscPerc: (0).toFixed(2),
    B_LDiscAmt: (0).toFixed(2),
    B_TDiscPerc: (0).toFixed(2),
    B_TDiscAmt: (0).toFixed(2),
    B_FocFlag: "N",
    B_AprmtFlag: "",
    B_FocAmt: (0).toFixed(2),
    B_NetAmt: (0).toFixed(2), //taxable Amt

    B_LC: (0).toFixed(2),
    B_Charges1: (0).toFixed(2),
    B_Charges2: (0).toFixed(2),
    B_Rounding: (0).toFixed(2),
    B_LandVal: (0).toFixed(2),
    B_RSP: (0).toFixed(2),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefNo1: "",
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo4: (0).toFixed(2),
    B_RefNo5: (0).toFixed(2),
    B_RefNo6: (0).toFixed(2),
    B_URate_Fixed: (0).toFixed(2),
    B_CostPr: (0).toFixed(2),
    B_ExciseTaxPerc: (0).toFixed(2),
    B_ExciseTaxAmt: (0).toFixed(2),
    B_ExciseTaxNetAmt: (0).toFixed(2),

    TaxableAmt: "",
    Narration: "",
    Itm_DefUnit: "",
    Itm_SalUnit: "",
  });

  const [sFooterObj, setFooterObj] = useState({
    A_GrossAmt: (0).toFixed(2),
    A_TDiscAmt: (0).toFixed(2),
    A_LDiscAmt: (0).toFixed(2),
    A_FocAmt: (0).toFixed(2),
    A_NetExcise: (0).toFixed(2),
    A_Tax: (0).toFixed(2),
    A_Tax2: (0).toFixed(2),
    A_AddCess: (0).toFixed(2),
    A_LandVal: (0).toFixed(2),
  });

  const [sDiscPerModelObj, setDiscPerModelObj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxSalesQuotationHead.A_DiscPerc,
  });

  let vBufferObjInit = {
    B_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
    B_VocNo:
      vRdxSalesQuotationHead.A_VocNo === ""
        ? 0
        : vRdxSalesQuotationHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(2),
    B_URateFc: (0).toFixed(2),
    B_URateLc: (0).toFixed(2),
    B_GrossAmt: (0).toFixed(2),
    B_LDiscPerc: (0).toFixed(2),
    B_LDiscAmt: (0).toFixed(2),
    B_TDiscPerc: (0).toFixed(2),
    B_TDiscAmt: (0).toFixed(2),
    B_FocFlag: "N",
    B_AprmtFlag: "",
    B_FocAmt: (0).toFixed(2),
    B_NetAmt: (0).toFixed(2), //taxable Amt

    B_LC: (0).toFixed(2),
    B_Charges1: (0).toFixed(2),
    B_Charges2: (0).toFixed(2),
    B_Rounding: (0).toFixed(2),
    B_LandVal: (0).toFixed(2),
    B_RSP: (0).toFixed(2),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefNo1: "",
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo4: (0).toFixed(2),
    B_RefNo5: (0).toFixed(2),
    B_RefNo6: (0).toFixed(2),
    B_URate_Fixed: (0).toFixed(2),
    B_CostPr: (0).toFixed(2),
    B_ExciseTaxPerc: (0).toFixed(2),
    B_ExciseTaxAmt: (0).toFixed(2),
    B_ExciseTaxNetAmt: (0).toFixed(2),

    TaxableAmt: "",
    Narration: "", //FIELD8
    Itm_DefUnit: "",
    Itm_SalUnit: "",
  };
  const [sItemStock, setItemStock] = useState({
    rpStock: "",
    wmsStock: "",
    msp: "",
    costpr: "",
    OpenBinStock: "",
  });
  const [sCommonError, setCommonError] = useState("");

  let vErrorMessageInit = {
    A_VocTyp: "",
    A_VocNo: "",
    A_PostDt: "",
    A_RefNo: "",
    A_RefDt: "",
    A_Loc: "",
    A_PayMode: "",
    A_Curr: "",
    A_ExRate: "",
    A_Party: "",
    A_PartyName: "",
    A_CUSTFIELD3: "",
    A_Type: "",
    A_Taxable: "",
    A_Buyer: "",
    A_Narr: "",
    A_Rounding: "",
    A_DiscPerc: "",

    //Detail

    B_Srno: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: "",
    B_Unit: "",
    B_BaseQty: "",
    B_URateFc: "",
    B_URateLc: "",
    B_GrossAmt: "",
    B_LDiscPerc: "",
    B_LDiscAmt: "",
    B_TDiscPerc: "",
    B_TDiscAmt: "",
    B_FocFlag: "",
    B_FocAmt: "",
    B_ExciseTaxAmt: "",
    B_ExciseTaxNetAmt: "",
    B_NetAmt: "",

    B_LandVal: "",
    Narration: "",
  };
  const [sErrorMsg, setErrorMsg] = useState(vErrorMessageInit);

  const [sErrorMsgDiscountModal, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });

  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };

  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: sLocation[0]?.UID ? sLocation[0]?.UID : "",
    RefNo: "",
    Party: "All",
    PartyName: "All",
  });
  const [sItemUnit, setItemUnit] = useState([]);
  const [sSearchModal, setSearchModal] = useState(false);
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sGridSalesHistoryRowData, setGridSalesHistoryRowData] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]);
  const [sSearchGridData, setSearchGridData] = useState([]); //for item search
  const [sNarrationSearchGridFullData, setNarrationSearchGridFullData] =
    useState([]); //for Narration full data
  const [sNarrationSearchGridData, setNarrationSearchGridData] = useState([]); //for Narration search
  const [sCustSearchGridData, setCustSearchGridData] = useState([]); //for ARR FOR CUSTOMER SEARCH
  const [sDiscountPercentageModal, setDiscountPercentageModal] =
    useState(false);

  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const fOpenReverseTransactionModal = () => {
    setReverseTransactionModal(true);
  };
  const fCloseReverseTransactionModal = (e) => {
    setReverseTransactionModal(false);
  };

  const fOpenDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(true);
    setDiscPerModelObj((obj) => ({
      ...obj,
      A_TDiscAmt: sFooterObj.A_TDiscAmt,
      A_DiscPerc: vRdxSalesQuotationHead.A_DiscPerc,
    }));
  };

  const fCloseDiscountPercentageModal = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };

  const [sAuditModal, setAuditModal] = useState(false);
  const fOpenAuditModal = (e) => {
    setAuditModal(true);
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };

  // const [sPrintModal, setPrintModal] = useState(false);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      // http://172.11.7.250:8020/(S(fah1uyi1oequz2lwbxpfqbh4))
      //Sales/SalesQuotation?TrnTyp=INV05&VocTyp=QS01&VocNo=EDGFM00002&prntyp=WIWD
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL;

      let urlPrint =
        webReport?.Val +
        "Sales/SalesQuotation?trntyp=" +
        sTrnTyp +
        "&VocTyp=" +
        vRdxSalesQuotationHead.A_VocTyp +
        "&VocNo=" +
        vRdxSalesQuotationHead.A_VocNo +
        "&prntyp=" +
        xPrnTyp;
      console.log(urlPrint);
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [
      vRdxSalesQuotationHead.A_VocNo,
      vRdxSalesQuotationHead.A_VocTyp,
      vRdxDBKernObj,
    ]
  );

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: sLocation[0].UID,
      RefNo: "",
      SalesGroup: sGCSeachSalesGroupSearch[0]?.UId,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModal(true);
    document.getElementById("SalesQuotationSearch")?.blur();
    // SALESGROUPSSEARCH_GETROW
    let iSalesGroupArr = await GetSalesGroupSearch(
      vRdxSalesQuotationHead.A_Loc
    );
    if (iSalesGroupArr.length > 0) {
      setGCSeachSalesGroupSearch(iSalesGroupArr);
      setSearchModalObj({
        ...sSearchModalObj,
        Loc: sLocation[0]?.UID,
        SalesGroup: iSalesGroupArr[0]?.UId,
        Party: "All",
        PartyName: "All",
      });
      GetSearchValue("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALL", vSelectedValue);
  };

  const fonChangePartyModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
      PartyName: vSelectedValue.AcCd,
    }));
    GetSearchValue("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UID,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UID);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const fonChangeRefNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // if (new Date(event.target.value) > new Date("01-01-1990")) {
    //   GetSearchValue("", "APICALLDATE", changedDate);
    // }
  };

  //TODO FULLSEARCH ,UNITARR ,AND CALCULATION
  const fItemCodeDependency = async (vItemSearchFull) => {
    let { HeadObject } = SalesQuotationRo();
    if (vItemSearchFull.length > 0) {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: vItemSearchFull[0].ItmCd,
        B_ItmName: vItemSearchFull[0].Name2,
        B_Barcode: vItemSearchFull[0].BarCode,
      }));
      let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd);

      let iUnit = vItemSearchFull[0]?.DefUnit || "";

      if (!iUnit) {
        iUnit = vItemSearchFull[0]?.SalUOM || "";
      }

      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });

      if (!vItemUnitSet) {
        iUnit = currentUnitArr[0]?.Unit || "";

        vItemUnitSet = currentUnitArr.find((obj) => {
          return obj.Unit === iUnit;
        });
      }
      await Unit_Onchange_001(iUnit, vItemUnitSet, vItemSearchFull[0]?.ItmCd);

      //new added
      await ItemsAliasListSearch(HeadObject.A_Loc, vItemSearchFull[0].ItmCd);
      await GetItemNarration(vItemSearchFull[0].ItmCd, HeadObject.A_Loc);
    } else {
      fAlertToast("FAILED", "Error in Exact Search");
    }
  };

  const Unit_Onchange_001 = async (
    xUnit = "",
    xUnitObj = {},
    xItemCode = sBufferObj.B_Itmcd
  ) => {
    let { HeadObject } = SalesQuotationRo();
    let currentPackQty = "";

    if (!!xUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: xUnitObj.Unit,
        B_UnitName: xUnitObj.Name1,
        B_PackQty: xUnitObj.PackQty,
      }));
      currentPackQty = xUnitObj?.PackQty;
    }

    let currentUnitRateArr = await GetUnitRate(xItemCode, xUnit);

    let currentUnitRateObj = {
      UnitRateFC: 0,
      DiscPerc: 0,
    };

    if (currentUnitRateArr.length > 0) {
      currentUnitRateObj = {
        UnitRateFC: currentUnitRateArr[0].UnitRateFC,
        DiscPerc: currentUnitRateArr[0].DiscPerc,
      };
      setBufferObj((obj) => ({
        ...obj,
        B_URateFc: currentUnitRateArr[0].UnitRateFC,
        B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      currentPackQty,
      HeadObject.A_ExRate,
      currentUnitRateObj.UnitRateFC,
      currentUnitRateObj.DiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0
    );
    setBufferObj((object) => ({
      ...object,
      B_Qty: sBufferObj.B_Qty,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_LandVal,
    }));
    setTimeout(() => {
      document.getElementsByName("B_Qty")[0]?.focus();
    }, 100);
    document.getElementsByName("B_Qty")[0]?.focus();
  };

  const fOpenContentItemSearchModalKey = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sBufferObj.B_Itmcd == "") {
        let vItemFullSearchDataObj = {
          anyData: sBufferObj.B_ItmName,
          transType: "F",
          report: "Y",
          loc: vRdxSalesQuotationHead.A_Loc,
        };
        const vItemSearchFull = await fExecuteAPI(
          "SEARCHEXACTITEM_GETROW",
          vItemFullSearchDataObj
        );

        if (vItemSearchFull?.ResultSet?.length > 0) {
          fItemCodeDependency(vItemSearchFull?.ResultSet);
        } else {
          fOnClickDropdownItemSearchModalKey(e);
        }
      } else {
        setTimeout(() => {
          document.getElementsByName("B_Qty")[0]?.focus();
        }, 200);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxSalesQuotationHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        0, //tax1%
        0, //tax%2
        0, //sBufferObj.B_Ad_PCRate,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        Itm_DefUnit: "",
        Itm_SalUnit: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_URateFc: 0,
        B_LDiscPerc: 0,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      }));
      setItemStock((obj) => ({
        ...obj,
        rpStock: "",
        wmsStock: "",
        msp: "",
        costpr: "",
        OpenBinStock: "",
      }));
      setItemUnit([]);
    }
  };

  //ItemSearch Dropdowm
  const [ToggleDropdown, setToggleDropdown] = useState(false);

  const handleClick = useCallback(() => {
    if (ToggleDropdown) {
      setToggleDropdown(false);
      setSearchGridData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setToggleDropdown(true);
    }
  }, [ToggleDropdown]);

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxSalesQuotationHead.A_Loc,
        setSearchGridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fOnClickDropdownItemSearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setItemSearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_ItmName,
      }));
      if (sBufferObj.B_ItmName != "") {
        GetSearchItem(
          sBufferObj.B_ItmName,
          "Any",
          vRdxSalesQuotationHead.A_Loc,
          setSearchGridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      handleClick();
    }
  };

  const fonChangeInputUnit = async (event, selectArr) => {
    var vSelectedObj = selectArr?.find((option, index) => {
      return option.Unit == event.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vSelectedObj?.Unit,
      B_UnitName: vSelectedObj?.Name1,
      B_PackQty: vSelectedObj?.PackQty,
    }));

    await Unit_Onchange_001(vSelectedObj?.Unit, vSelectedObj);
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
      setToggleGrid(false);
    }
  };
  const fFocusShowSalesHistoryGrid = async () => {
    let vSalesHistoryArr = await GetSalesHistory(sBufferObj.B_Itmcd);
    if (vSalesHistoryArr.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
  };

  const fonChangeInputQty = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      event.target.value,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_Qty: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    }));
  };

  const [sNarrationToggleDropdown, setNarrationToggleDropdown] =
    useState(false);

  const fonChangeInputNarration = (event) => {
    setBufferObj((obj) => ({ ...obj, Narration: event }));
    ffilterNarrationDropDownSearch(event, sNarrationSearchGridFullData);
  };

  const fNarrationKeyEnter = (e) => {
    if (e.key == "Enter" || e._reactName === "onClick") {
      setNarrationToggleDropdown(!sNarrationToggleDropdown);
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const ffilterNarrationDropDownSearch = useCallback((xValue, xArray) => {
    let vNewFilterSearchArr = xArray?.filter((obj) => {
      return (
        obj.Code.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase()) ||
        obj.Name.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase())
      );
    });
    if (xValue !== "") {
      setNarrationSearchGridData(vNewFilterSearchArr);
    } else {
      setNarrationSearchGridData(xArray);
    }
  }, []);

  const fonChangeInputSupervisorAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputOtherAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputItemName = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
    // ffilterDropDownSearch(event.target.value, sSearchGridDataFullData);
  };

  const fonChangeInputUnitRateFC = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      event.target.value,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    }));
  };
  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0,
      0,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      //B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
      B_URateFc,
    }));
  };
  const fUnitRateFCSave_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxSalesQuotationHead.A_DocStat == "ENTER"
      ) {
        document.getElementsByName("B_URateFc")[0]?.blur();
        fSave();
      }
    }, 1000);
  };
  //discAmt footer
  const fonChangeInputDiscount = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_DiscPerc: fcovertToNumber(event.target.value),
      })
    );
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: fcovertToNumber(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    });
  };

  //Discount% modal
  const fonChangeInputDiscountModal = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: Number(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    });
  };

  //DiscountAmt modal
  const fOnChangeTDiscAmtModal = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    setDiscPerModelObj({
      ...sDiscPerModelObj,
      A_DiscPerc: Number(vCheckValue) === 0 ? 0 : fcovertToNumber(vTDiscPer),
      A_TDiscAmt: Number(e.target.value),
    });
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(2),
    }));
  };

  const fFooter_Rounding_OnChange = (event) => {
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_Rounding: event.target.value,
      })
    );
    fLandValueCalc(event);
  };

  const fFooter_Rounding_Focus = (event) => {
    if (event.target.value == 0) {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_Rounding: "",
        })
      );
    }
  };

  const fFooter_Rounding_Blur = (event) => {
    const iRounding = fcovertToNumber(event.target.value);
    if (iRounding == 0) {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_Rounding: (0).toFixed(4),
        })
      );

      fLandValueCalc(event);
    }
  };

  const fonChangeInputLDisc = (event) => {
    if (event.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxSalesQuotationHead.A_ExRate,
        sBufferObj.B_URateFc,
        event.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        0,
        0,
        0,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        [event.target.name]: event.target.value,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0,
      0,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
      B_LDiscPerc,
    }));
  };

  const fonChangeInputExcise = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      event.target.value,
      0,
      0,
      0,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    }));
  };

  const fonChangeCheckBoxFoc = (event) => {
    let isChecked = event.target.checked ? "Y" : "N";
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxSalesQuotationHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      isChecked,
      sBufferObj.B_ExciseTaxAmt,
      0,
      0,
      0,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_FocFlag: isChecked,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_LandVal,
    }));
  };

  const [xAuditId, setAuditId] = useState("All");
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };

  //GCItemSearch
  const fOnRowClick = async (e) => {
    let vItemFullSearchDataObj = {
      anyData: e?.row?.ItmCd,
      transType: "F",
      report: "Y",
      loc: vRdxSalesQuotationHead.A_Loc,
    };
    const vItemSearchFull = await fExecuteAPI(
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    if (vItemSearchFull?.ResultSet?.length > 0) {
      fItemCodeDependency(vItemSearchFull?.ResultSet);
      if (!vIsDownKeyPressed) {
        setToggleDropdown(false);
        document.getElementsByName("B_Qty")[0]?.focus();
      }
      vIsDownKeyPressed = false;
    } else {
      fAlertToast("FAILED", "Item is Empty");
    }
  };

  //GCSimpleSearch for customer
  const fRowClick = async (e) => {
    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxSalesQuotationHead.A_Loc,
      e?.row?.AcCd
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }
    //if inter.comp then tax group should be 0

    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        A_Buyer: e?.row?.SalesmanCode,
        A_CUSTFIELD3: vDefaultTaxType,
      })
    );
    if (!vIsDownKeyPressedSimpleSearch) {
      GetDefcustomersetting(e?.row?.AcCd, vRdxSalesQuotationHead.A_Loc);
      // setHeaderSearchResultArr([]);
      setTimeout(() => {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }, 500);
      setCustomerToggleDropdown(false);
    }
    vIsDownKeyPressedSimpleSearch = false;
  };

  //GCSearchBtn
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
    fCloseSearchModal();
    fClearSearchModal();
  };
  //GCSearchBtn Start
  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sSearchModalObj.PartyName,
      }));
      if (sSearchModalObj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sSearchModalObj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          sSearchModalObj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          GetSearchValue(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document?.getElementsByClassName("Mui-selected")?.length;
        if (selectedLength === 0) {
          let tabel = document?.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GetSearchValue("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };

  //GCSearchBtn End

  //Narration input search
  const OnRowNarrationClick = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e?.row?.Name,
    }));
    setNarrationToggleDropdown(false);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vErrorMessageInit);
    setGridSalesHistoryRowData([]);
    setRevNarr("");
    setToggleGrid(false);
  };

  const fNew = async (VocNo = "") => {
    fClearErrorMsg();

    if (sBufferObj.B_ItmName == "") {
      let idefaultTaxTypeValue = "OTTRN001";
      let iDefaultTaxType = await GetTransTaxType(
        sLocation[0].UID, //locaation
        ""
      );

      if (Object.keys(iDefaultTaxType[0]).length != 0) {
        idefaultTaxTypeValue = iDefaultTaxType[0]?.TaxType;
      }

      fNewHead(VocNo);
      fNewDetail(VocNo, 0, sDocLoading[0].VocTyp, idefaultTaxTypeValue);

      if (sBufferObj.B_Itmcd == "") {
        document.getElementsByName("A_PartyName")[0]?.focus();
      } else {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }
    } else {
      fNewDetail(
        vRdxSalesQuotationHead.A_VocNo,
        vRdxSalesQuotationHead.A_Rounding,
        vRdxSalesQuotationHead.A_VocTyp,
        vRdxSalesQuotationHead.A_CUSTFIELD3
      );
    }
  };

  const fNewHead = async (VocNo = "") => {
    fClearErrorMsg();
    dispatch(SalesQuotation_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    let idefaultTaxTypeValue = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      sLocation[0].UID, //locaation
      ""
    );

    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType[0]?.TaxType;
    }

    dispatch(
      Set_SalesQuotation_HeadObject_New({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: sLocation[0]?.UID,
        A_Curr: sCurrency[0]?.Uid,
        A_Currname: sCurrency[0]?.Name1,
        A_ExRate: sCurrency[0]?.Rate,
        A_Type: vRdxPricelevel[0],
        A_Buyer: sSalesman[0]?.UId,
        A_CUSTFIELD3: idefaultTaxTypeValue,
      })
    );
    // let currentPayMode = fDefaultPayload(
    //   sDocLoading[0]?.Paymode,
    //   dispatch,
    //   setPaymodeEnable
    // );
    await fDefaultPayload(
      "CREDIT", //based on A_INV_TYPE
      dispatch,
      setPaymodeEnable
    );

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: (0).toFixed(2),
      A_TDiscAmt: (0).toFixed(2),
      A_LDiscAmt: (0).toFixed(2),
      A_FocAmt: (0).toFixed(2),
      A_NetExcise: (0).toFixed(2),
      A_Tax: (0).toFixed(2),
      A_Tax2: (0).toFixed(2),
      A_AddCess: (0).toFixed(2),
      A_LandVal: (0).toFixed(2),
    }));
    // RefNoFocusOnLoad.current.focus();
  };

  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    fClearErrorMsg();
    const { HeadObject } = SalesQuotationRo();
    setBufferObj(vBufferObjInit);
    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
    }));

    setItemUnit([]);
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      0, //tax1%
      0, //tax%2
      0, //sBufferObj.AddCess,
      0 //Rounding
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_Rounding,
      B_LandVal,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, xVocTyp);

    document?.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fReverse = (e) => {
    fCloseReverseTransactionModal();
    confirmAlert({
      title: "Reverse",
      message: "Are you sure to Reverse.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => fSave(),
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => setRevNarr(""),
        },
      ],
    });
  };
  let timeout = null;

  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxSalesQuotationHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };
  const validation_Save_ServerSide = async () => {
    const { HeadObject } = SalesQuotationRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let iBr = sLocation.find((item) => item.UId == HeadObject.A_Loc);

    let obj = {
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_Br: iBr?.BranchCode || "",
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_Party: HeadObject.A_Party,
      v_A_Loc: HeadObject.A_Loc,
      v_A_Type: HeadObject.A_Type,

      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: sBufferObj.B_Qty,
      v_B_Unit: sBufferObj.B_Unit,
      v_B_NetAmt: sBufferObj.B_NetAmt,
      Paymode: HeadObject.A_PayMode,
      RSP: sBufferObj.B_URateLc,
      NumerFormat: "N" + HeadObject.A_Rounding,
      Foc: sBufferObj.B_FocFlag,
    };
    let resp = await validationINV05_SalesQuotation_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );

        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (vErrorMessageInit.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg || "error in validationWMINV03 "
          );
        }

        document
          ?.getElementsByName([resp?.response?.data?.message?.field])[0]
          ?.focus();
      }
      return false;
    }
  };
  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxSalesQuotationHead.A_DocStat
  ) => {
    if (vRdxSalesQuotationHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await fSaveHead(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await fSaveHead(xsave, docstatus);
    }
  };
  const fSave = async (e) => {
    fCloseReverseTransactionModal();
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        vRdxSalesQuotationHead.A_DocStat == "POST" ||
        vRdxSalesQuotationHead.A_DocStat == "DRAFT"
      ) {
        if (sRevNarr == "") {
          fOpenReverseTransactionModal();
        } else {
          let reverseResp = await GetRevereTransaction();
          if (reverseResp?.status === 200) {
            fClearErrorMsg();
            setRevNarr("");
            dispatch(
              Set_SalesQuotation_HeadObject_DocStatus({
                A_DocStat: "ENTER",
              })
            );
            fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
          }
        }
      } else if (vRdxSalesQuotationHead.A_DocStat !== "ENTER") {
        fAlertToast("FAILED", "Document status should be  Enter");
      } else if (vRdxSalesQuotationHead.A_DocStat == "ENTER") {
        let validation = fValidationHead();
        if (!validation) return;

        let validationDetil = fValidationDetail();
        if (!validationDetil) return;
        // let server_Validation =true

        let server_Validation = await validation_Save_ServerSide();
        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
      // setIsSaved(false);
    }, 800);
  };

  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = SalesQuotationRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let iBr = sLocation.find((item) => item.UId == HeadObject.A_Loc);

    let obj = {
      //approve cnfimartion:HeadObject.qqqqq,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_A_PayMode: HeadObject.A_PayMode,
      v_A_Party: HeadObject.A_Party,
      Loc: HeadObject.A_Loc,
      UserCd: vRdxUserInfoObj.UserID,
      NumerFormat: "N" + HeadObject.A_Rounding,
      v_A_Br: iBr?.BranchCode || "",
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Type: HeadObject.A_Type,
    };
    let resp = await ApproveINV05_SalesQuotation_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (vErrorMessageInit.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg || "error in validationWMINV03 "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      let validation = fValidationHead();
      if (!validation) return;

      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }
      if (sDetailGridData.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      if (!Searver_ValidationApprove) return;

      if (!!Searver_ValidationApprove) {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Are you want to Approve..",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: async () => {
                  await fSaveHead(false, xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  return;
                },
              },
            ],
          });
        }, 200);
      }
    }, 800);
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxSalesQuotationHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document?.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    }
  };

  const fAudit = async (e) => {
    GetTransAudit(sAuditSelectArr[0]?.id);
    fOpenAuditModal();
  };

  const fMove_First = (e) => {
    fMove(sUser_Doc_Arr[0].A_VocTyp, sUser_Doc_Arr[0].A_VocNo, 1);
  };

  const fMove_Last = (e) => {
    fMove(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo,
      sUser_Doc_Arr.length
    );
  };

  const fMove_Previouse = (e) => {
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fMove(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        row
      );
    }
  };

  const fMove_Next = (e) => {
    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fMove(
        sUser_Doc_Arr[row - 1].A_VocTyp,
        sUser_Doc_Arr[row - 1].A_VocNo,
        row
      );
    }
  };

  const fMove = (xA_VocTyp, xA_VocNo, NavDocValue) => {
    fClearErrorMsg();
    setItemStock((obj) => ({
      ...obj,
      rpStock: "",
      wmsStock: "",
      msp: "",
      costpr: "",
      OpenBinStock: "",
    }));
    setBufferObj(vBufferObjInit);
    fDisplay(xA_VocTyp, xA_VocNo);
    setNavDocValue(NavDocValue);
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //view end

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = SalesQuotationRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = SalesQuotationRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };
  //summary end
  const fValidationHead = () => {
    let iRes = true;

    if (
      vRdxSalesQuotationHead.A_VocTyp === "" ||
      vRdxSalesQuotationHead.A_VocTyp === null ||
      vRdxSalesQuotationHead.A_VocTyp === undefined
    ) {
      fAlertToast("FAILED", "VocTyp should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_VocTyp: "VocTyp should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_VocNo === "" ||
      vRdxSalesQuotationHead.A_VocNo === null ||
      vRdxSalesQuotationHead.A_VocNo === undefined
    ) {
      fAlertToast("FAILED", "VocNo should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_VocNo: "VocNo should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_PostDt === "" ||
      vRdxSalesQuotationHead.A_PostDt === null ||
      vRdxSalesQuotationHead.A_PostDt === undefined
    ) {
      fAlertToast("FAILED", "PostDt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PostDt: "PostDt should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_RefNo.toUpperCase() === "POS" ||
      vRdxSalesQuotationHead.A_RefNo === null ||
      vRdxSalesQuotationHead.A_RefNo === undefined
    ) {
      fAlertToast("FAILED", "Text should not be POS");
      setErrorMsg((obj) => ({
        ...obj,
        A_RefNo: "Text should not be POS",
      }));
      iRes = false;
    } else if (vRdxSalesQuotationHead.A_RefNo.toUpperCase() === "CREDIT") {
      fAlertToast("FAILED", "Text should not be CREDIT");
      setErrorMsg((obj) => ({
        ...obj,
        A_RefNo: "Text should not be CREDIT",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_Party === "" ||
      vRdxSalesQuotationHead.A_Party === null ||
      vRdxSalesQuotationHead.A_Party === undefined
    ) {
      fAlertToast("FAILED", "Party should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "Party should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_PartyName === "" ||
      vRdxSalesQuotationHead.A_PartyName === null ||
      vRdxSalesQuotationHead.A_PartyName === undefined
    ) {
      fAlertToast("FAILED", "PartyName should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "PartyName should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_Curr === "" ||
      vRdxSalesQuotationHead.A_Curr === null ||
      vRdxSalesQuotationHead.A_Curr === undefined
    ) {
      fAlertToast("FAILED", "Curr should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Curr: "Curr should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_ExRate === "" ||
      vRdxSalesQuotationHead.A_ExRate === null ||
      vRdxSalesQuotationHead.A_ExRate === undefined
    ) {
      fAlertToast("FAILED", "ExRate should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_ExRate: "ExRate should not be empty",
      }));
      iRes = false;
    } else if (Number(vRdxSalesQuotationHead.A_ExRate) === 0) {
      fAlertToast("FAILED", "ExRate should not be zero");

      setErrorMsg((obj) => ({ ...obj, A_ExRate: "ExRate should not be zero" }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_PayMode === "" ||
      vRdxSalesQuotationHead.A_PayMode === null ||
      vRdxSalesQuotationHead.A_PayMode === undefined
    ) {
      fAlertToast("FAILED", "PayMode should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PayMode: "PayMode should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_Type === "" ||
      vRdxSalesQuotationHead.A_Type === null ||
      vRdxSalesQuotationHead.A_Type === undefined
    ) {
      fAlertToast("FAILED", "Type should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Type: "Type should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_CUSTFIELD3 === "" ||
      vRdxSalesQuotationHead.A_CUSTFIELD3 === null ||
      vRdxSalesQuotationHead.A_CUSTFIELD3 === undefined
    ) {
      fAlertToast("FAILED", "Tax Type should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_CUSTFIELD3: "Tax Type should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_Loc === "" ||
      vRdxSalesQuotationHead.A_Loc === null ||
      vRdxSalesQuotationHead.A_Loc === undefined
    ) {
      fAlertToast("FAILED", "Location should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Loc: "Location should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxSalesQuotationHead.A_RefDt === "" ||
      vRdxSalesQuotationHead.A_RefDt === null ||
      vRdxSalesQuotationHead.A_RefDt === undefined
    ) {
      fAlertToast("FAILED", "Reference Date should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_RefDt: "Reference Date should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_Buyer === "" ||
      vRdxSalesQuotationHead.A_Buyer === null ||
      vRdxSalesQuotationHead.A_Buyer === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Buyer should not be Empty");
      setErrorMsg((obj) => ({ ...obj, A_Buyer: "Buyer should not be Empty" }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_Taxable === "" ||
      vRdxSalesQuotationHead.A_Taxable === null ||
      vRdxSalesQuotationHead.A_Taxable === undefined
    ) {
      fAlertToast("FAILED", "Taxable should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Taxable: "Taxable should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_Rounding === "" ||
      vRdxSalesQuotationHead.A_Rounding === null ||
      vRdxSalesQuotationHead.A_Rounding === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Rounding should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Rounding should not be Empty",
      }));
      iRes = false;
    }

    if (sFooterObj.A_LandVal < 0) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Transaction amount should be greater than zero");
      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Transaction amount should be greater than zero",
      }));
      iRes = false;
    }

    if (
      vRdxSalesQuotationHead.A_DiscPerc === "" ||
      vRdxSalesQuotationHead.A_DiscPerc === null ||
      vRdxSalesQuotationHead.A_DiscPerc === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Discount percentage should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Discount percentage should not be empty",
      }));
      iRes = false;
    } else if (
      Number(vRdxSalesQuotationHead.A_DiscPerc) !== 0 &&
      Number(sFooterObj.A_TDiscAmt) === 0
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Check discount percentage2");
      setErrorMsg((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage2",
      }));
      iRes = false;
    } else if (
      vRdxSalesQuotationHead.A_DiscPerc == 0 &&
      sFooterObj.A_TDiscAmt != 0
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Check discount percentage1");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage1",
      }));
      iRes = false;
    } else if (
      Number(vRdxSalesQuotationHead.A_DiscPerc) > 100 ||
      Number(vRdxSalesQuotationHead.A_DiscPerc) < 0
    ) {
      fAlertToast("FAILED", "Discount percentage must be between 0 and 100");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc Percentage must be greater than 0 and less than or equal to 100",
      }));
      iRes = false;
    }

    return iRes;
  };

  const fValidationDetail = () => {
    let iRes = true;

    if (vRdxSalesQuotationHead.A_DocStat != "ENTER") {
      fAlertToast("FAILED", "Check Doc Status");
      iRes = false;
    }

    if (sBufferObj.B_Srno === "") {
      fAlertToast("FAILED", "Serial number should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_Srno: "Serial number should not be empty",
      }));
      iRes = false;
    }

    if (sBufferObj.B_Itmcd === "") {
      fAlertToast("FAILED", "Item code should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_ItmName: "Item code should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ItmName === "" ||
      sBufferObj.B_ItmName === null ||
      sBufferObj.B_ItmName === undefined
    ) {
      fAlertToast("FAILED", "Item name should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_ItmName: "Item name should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Qty === null ||
      sBufferObj.B_Qty === undefined
    ) {
      fAlertToast("FAILED", "Enter quantity");
      setErrorMsg((obj) => ({ ...obj, B_Qty: "Enter quantity" }));
      iRes = false;
    } else if (Number(sBufferObj.B_Qty) <= 0) {
      fAlertToast("FAILED", "Quantity should be greater than zero");
      setErrorMsg((obj) => ({
        ...obj,
        B_Qty: "Quantity should be greater than zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Unit === "" ||
      sBufferObj.B_Unit === null ||
      sBufferObj.B_Unit === undefined
    ) {
      fAlertToast("FAILED", "Select unit");
      setErrorMsg((obj) => ({ ...obj, B_Unit: "Select unit" }));
      iRes = false;
    }

    if (
      sBufferObj.B_PackQty === "" ||
      sBufferObj.B_PackQty === null ||
      sBufferObj.B_PackQty === undefined
    ) {
      fAlertToast("FAILED", "Pack quantity should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_PackQty: "Pack quantity should not be empty",
      }));
      iRes = false;
    } else if (Number(sBufferObj.B_PackQty) === 0) {
      fAlertToast("FAILED", "Pack quantity should not be zero");
      setErrorMsg((obj) => ({
        ...obj,
        B_PackQty: "Pack quantity should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_BaseQty === "" ||
      sBufferObj.B_BaseQty === null ||
      sBufferObj.B_BaseQty === undefined
    ) {
      fAlertToast("FAILED", "Base quantity should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_BaseQty: "Base quantity should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_URateFc === "" ||
      sBufferObj.B_URateFc === null ||
      sBufferObj.B_URateFc === undefined
    ) {
      fAlertToast("FAILED", "Enter unit rate [F.C]");
      setErrorMsg((obj) => ({ ...obj, B_URateFc: "Enter unit rate [F.C]" }));
      iRes = false;
    } else if (Number(sBufferObj.B_URateFc) === 0) {
      fAlertToast("FAILED", "Unit rate [F.C] should not be zero");
      setErrorMsg((obj) => ({
        ...obj,
        B_URateFc: "Unit rate [F.C] should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_URateLc === "" ||
      sBufferObj.B_URateLc === null ||
      sBufferObj.B_URateLc === undefined
    ) {
      fAlertToast("FAILED", "Enter unit rate [L.C]");
      setErrorMsg((obj) => ({ ...obj, B_URateLc: "Enter unit rate [L.C]" }));
      iRes = false;
    } else if (Number(sBufferObj.B_URateLc) <= 0) {
      fAlertToast("FAILED", "Unit rate [L.C] should not be zero");
      setErrorMsg((obj) => ({
        ...obj,
        B_URateLc: "Unit rate [L.C] should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_GrossAmt === "" ||
      sBufferObj.B_GrossAmt === null ||
      sBufferObj.B_GrossAmt === undefined
    ) {
      fAlertToast("FAILED", "Gross amount should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_GrossAmt: "Gross amount should not be empty",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_LDiscPerc === "" ||
      sBufferObj.B_LDiscPerc === null ||
      sBufferObj.B_LDiscPerc === undefined
    ) {
      fAlertToast("FAILED", "LDiscPerc should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscPerc should not be empty",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) == 0 &&
      Number(sBufferObj.B_LDiscAmt) != 0
    ) {
      fAlertToast("FAILED", "LDiscAmt should be zero when LDiscPerc is zero");
      setErrorMsg((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should be zero",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) != 0 &&
      Number(sBufferObj.B_LDiscAmt) <= 0
    ) {
      fAlertToast(
        "FAILED",
        "LDiscAmt should not be zero when LDiscPerc is non-zero"
      );
      setErrorMsg((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should not be zero",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      fAlertToast("FAILED", "LDiscPerc must be between 0 and 100");
      setErrorMsg((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscPerc must be between 0 and 100",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_LDiscAmt === "" ||
      sBufferObj.B_LDiscAmt === null ||
      sBufferObj.B_LDiscAmt === undefined
    ) {
      fAlertToast("FAILED", "LDiscAmt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_LDiscAmt: "LDiscAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TDiscPerc === "" ||
      sBufferObj.B_TDiscPerc === null ||
      sBufferObj.B_TDiscPerc === undefined
    ) {
      fAlertToast("FAILED", "TDiscPerc should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TDiscAmt === "" ||
      sBufferObj.B_TDiscAmt === null ||
      sBufferObj.B_TDiscAmt === undefined
    ) {
      fAlertToast("FAILED", "TDiscAmt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_TDiscAmt: "TDiscAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_FocFlag === "" ||
      sBufferObj.B_FocFlag === null ||
      sBufferObj.B_FocFlag === undefined
    ) {
      fAlertToast("FAILED", "FocFlag should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_FocAmt === "" ||
      sBufferObj.B_FocAmt === null ||
      sBufferObj.B_FocAmt === undefined
    ) {
      fAlertToast("FAILED", "FocAmt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxAmt === "" ||
      sBufferObj.B_ExciseTaxAmt === null ||
      sBufferObj.B_ExciseTaxAmt === undefined
    ) {
      fAlertToast("FAILED", "ExciseTaxAmt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxNetAmt === "" ||
      sBufferObj.B_ExciseTaxNetAmt === null ||
      sBufferObj.B_ExciseTaxNetAmt === undefined
    ) {
      fAlertToast("FAILED", "ExciseTaxNetAmt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_NetAmt === "" ||
      sBufferObj.B_NetAmt === null ||
      sBufferObj.B_NetAmt === undefined
    ) {
      fAlertToast("FAILED", "Net amount should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_NetAmt: "Net amount should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_LandVal === "" ||
      sBufferObj.B_LandVal === null ||
      sBufferObj.B_LandVal === undefined
    ) {
      fAlertToast("FAILED", "Land value should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        B_LandVal: "Land value should not be empty",
      }));
      iRes = false;
    }

    return iRes;
  };

  //onchange we will not get value so 2 parameter added
  //GCItemSearch
  let vIsDownKeyPressed = false;

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        v_VocNo: sSearchModalObj.VocNo,
        v_PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("DD/MM/YYYY")
            : !!sSearchModalObj.PostDt
            ? moment(sSearchModalObj.PostDt).format("DD/MM//YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        v_RefNo: sSearchModalObj.RefNo,
        v_Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!sSearchModalObj.Party
            ? sSearchModalObj.Party
            : "All",
        v_Type: "",
        v_Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        v_Status: xAPICALL === "APICALL" ? xSTATUS : sSearchModalObj.Status,
        v_UserCd: vRdxuserInfo.UserID,
      };
      const vSearch = await inv05_SalesQuotation_Search_GETROW(vSearchObj);
      if (vSearch?.status === 200) {
        let vSearchArr = vSearch?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      }
    }
  };

  const fOpenHeadCustomerSearchModalKey = async (e, ModalName) => {

    if (e.key === "Enter" || e._reactName === "onClick") {
      const vSupplierSearchDataObj = {
        Typ: "D",
        Data: vRdxSalesQuotationHead?.A_PartyName ?? "",
      };

      const vSupplierSearch = await SubKonten_Search_Full_V3Api(
        vSupplierSearchDataObj
      );

      if (vSupplierSearch?.status === 200) {
        const rows = vSupplierSearch?.data?.ResultSet ?? [];
        if (rows.length > 0) {
          const vSupplier = rows[0];

          let vDefaultTaxType = "OTTRN001";
          let iDefaultTaxType = await GetTransTaxType(
            vRdxSalesQuotationHead.A_Loc,
            vSupplier?.AcCd
          );
          if (Object.keys(iDefaultTaxType[0]).length != 0) {
            vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
          }
          //if inter.comp then tax group should be 0

          if (!!vSupplier) {
            if (iDefaultTaxType.length > 0) {
              dispatch(
                Set_SalesQuotation_HeadObject_Set({
                  ...vRdxSalesQuotationHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                  A_Buyer: vSupplier?.SalesmanCode || "",
                  A_CUSTFIELD3: vDefaultTaxType,
                })
              );
              GetDefcustomersetting(
                vSupplier?.AcCd,
                vRdxSalesQuotationHead.A_Loc
              );
            } else {
              dispatch(
                Set_SalesQuotation_HeadObject_Set({
                  ...vRdxSalesQuotationHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                })
              );
            }

            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          } else {
            fOnClickDropdownCustomerSearchModalKey(e);
          }
          if (vRdxSalesQuotationHead.A_Party != "") {
            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          }
        } else {
          fOnClickDropdownCustomerSearchModalKey(e);
        }
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          // let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  //Customer Dropdowm
  const [sCustomerToggleDropdown, setCustomerToggleDropdown] = useState(false);
  const [sCustomerSearchDropdownObj, setCustomerSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const fOnChangeCustomer = (e) => {
    setCustomerSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fCustomerClick = useCallback(() => {
    if (sCustomerToggleDropdown) {
      setCustomerToggleDropdown(false);
      setCustSearchGridData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setCustomerToggleDropdown(true);
    }
  }, [sCustomerToggleDropdown]);

  const fOnKeyUpCustomer = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchCustomer(
        sCustomerSearchDropdownObj.Data,
        sCustomerSearchDropdownObj.Type,
        vRdxSalesQuotationHead.A_Loc,
        setCustSearchGridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );

          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fOnClickDropdownCustomerSearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setCustomerSearchDropdownObj((obj) => ({
        ...obj,
        Data: vRdxSalesQuotationHead.A_PartyName,
      }));
      if (vRdxSalesQuotationHead.A_PartyName != "") {
        GetSearchCustomer(
          vRdxSalesQuotationHead.A_PartyName,
          "Any",
          vRdxSalesQuotationHead.A_Loc,
          setCustSearchGridData
        );
      }
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
      fCustomerClick();
    }
  };

  //HEAD Component

  const fOnChangeSelectDocType = (event) => {
    var vSelectedObj = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_VocTyp: vSelectedObj.VocTyp,
        A_VocTypName: vSelectedObj.VocName,
      })
    );
    fDefaultPayload(vSelectedObj.Paymode, dispatch, setPaymodeEnable);
  };

  const fOnChangeSelectCurr = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_Curr: vCurrency.Uid,
        A_Currname: vCurrency.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );

    fonChangeGetValueExRate(vCurrency?.Rate);
  };

  const fOnChangeInputDate = useCallback(
    (event) => {
      if (
        event?.$d == "Invalid Date" ||
        event?.$d == null ||
        event?.$d === undefined ||
        event?.$d === ""
      ) {
        dispatch(
          Set_SalesQuotation_HeadObject_Set({
            ...vRdxSalesQuotationHead,
            A_PostDt: "",
          })
        );
      } else {
        dispatch(
          Set_SalesQuotation_HeadObject_Set({
            ...vRdxSalesQuotationHead,
            A_PostDt: event?.$d,
          })
        );
      }
      // dispatch(
      //   Set_SalesQuotation_HeadObject_Set({
      //     ...vRdxSalesQuotationHead,
      //     A_PostDt: event.$d,
      //   })
      // );
    },
    [vRdxSalesQuotationHead, dispatch]
  );

  const fOnChangeInputDateRefDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_RefDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SalesQuotation_HeadObject_Set({
    //     ...vRdxSalesQuotationHead,
    //     A_RefDt: event.$d,
    //   })
    // );
  };

  const fonChangeInput = useCallback(
    (event) => {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          [event.target.name]: event.target.value,
        })
      );
    },
    [vRdxSalesQuotationHead, dispatch]
  );
  const fonChangeInputTaxType = async (event) => {
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        [event.target.name]: event.target.value,
        A_Taxable:
          event.target.value == "OTTRN001" || event.target.value == "INTRN001"
            ? "Y"
            : "N",
      })
    );
    //if inter.comp then tax group should be 0
    if (sBufferObj.B_Itmcd != "") {
      let vItemFullSearchDataObj = {
        anyData: sBufferObj.B_Itmcd,
        transType: "F",
        report: "Y",
        loc: vRdxSalesQuotationHead.A_Loc,
      };
      const vItemSearchFull = await fExecuteAPI(
        "SEARCHEXACTITEM_GETROW",
        vItemFullSearchDataObj
      );
      if (vItemSearchFull.ResultSet.length > 0) {
        setBufferObj((object) => ({
          ...object,
          B_Itmcd: vItemSearchFull.ResultSet[0].ItmCd,
          B_ItmName: vItemSearchFull.ResultSet[0].Name2,
          Itm_DefUnit: vItemSearchFull.ResultSet[0].DefUnit,
          Itm_SalUnit: vItemSearchFull.ResultSet[0].SalUOM,
        }));
        var resObj = {
          B_Itmcd: vItemSearchFull.ResultSet[0].ItmCd,
          B_ItmName: vItemSearchFull.ResultSet[0].Name2,
          Itm_DefUnit: vItemSearchFull.ResultSet[0].DefUnit,
          Itm_SalUnit: vItemSearchFull.ResultSet[0].SalUOM,
        };
        await ItemsAliasListSearch(
          vRdxSalesQuotationHead.A_Loc,
          vItemSearchFull.ResultSet[0].ItmCd
        );
        GetItemNarration(
          vItemSearchFull.ResultSet[0].ItmCd,
          vRdxSalesQuotationHead.A_Loc
        );
        GetUnitArr(resObj);
      }
    }
  };

  const fonChangeInputCustomer = (event) => {
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_PartyName: event.target.value,
      })
    );
    if (
      event.target.value.length <
        vRdxSalesQuotationHead.A_PartyName.toString().length &&
      vMediaQuery &&
      event.target.name === "A_PartyName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      fOpenHeadCustomerSearchModalKey(vBackspaceObj);
    }
  };
  const fonChangeInputPayMode = useCallback(
    (event) => {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          [event.target.name]: event.target.value,
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [vRdxSalesQuotationHead]
  );
  const fonChangeInputTaxable = useCallback(
    (event) => {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          [event.target.name]: event.target.checked ? "Y" : "N",
        })
      );
    },
    [vRdxSalesQuotationHead, dispatch]
  );

  const fonChangeInputLocation = async (event) => {
    let iDefaultTaxType = await GetTransTaxType(
      event.target.value,
      vRdxSalesQuotationHead.A_Party
    );
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        [event.target.name]: event.target.value,
        A_CUSTFIELD3: iDefaultTaxType[0]?.TaxType,
      })
    );
    ItemsAliasListSearch(event.target.value, sBufferObj.B_Itmcd);
    fonChangeGetValueLocation(event.target.value);

    GetItemNarration(sBufferObj.B_Itmcd, event.target.value);
    GetDefcustomersetting(vRdxSalesQuotationHead.A_Party, event.target.value);
  };

  //getting value (ExRate) from head
  const fonChangeGetValueExRate = useCallback(
    (ExRate) => {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        ExRate,
        sBufferObj.B_URateFc,
        sBufferObj.B_LDiscPerc,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        0,
        0,
        0,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      }));
    },
    [sBufferObj]
  );

  //getting value (Location) from head
  const fonChangeGetValueLocation = async (xA_Loc) => {
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_Loc: xA_Loc,
      })
    );
  };

  // if any data value is not empty filter array
  //GCSimpleSearch
  let vIsDownKeyPressedSimpleSearch = false;

  //Footer Component
  const fonChangeSelectSalesMan = (event, selectArr) => {
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        A_Buyer: event.target.value,
      })
    );
  };

  const fonClickInputBlurDiscount = (event) => {
    if (event.target.value == "") {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_DiscAmt: (0).toFixed(2),
        })
      );
    }
  };
  const fonClickInputFocusDiscount = (event) => {
    if (event.target.value <= 0 || event.target.value == "") {
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_DiscAmt: "",
        })
      );
    }
  };
  const fonChangeInputFooter = (event) => {
    dispatch(
      Set_SalesQuotation_HeadObject_Set({
        ...vRdxSalesQuotationHead,
        [event.target.name]: event.target.value,
      })
    );
  };
  //if inter.comp then tax group should be 0

  //API Unit
  const GetUnitArr = async (xB_Itmcd) => {
    let vItemunitObj = {
      itemCd: xB_Itmcd,
    };

    const vItemUnitArr = await fExecuteAPI("GETITEMUNITS_GETROW", vItemunitObj);
    if (vItemUnitArr.Type === "SUCCESS") {
      if (vItemUnitArr.ResultSet.length > 0) {
        setItemUnit(vItemUnitArr.ResultSet);
        return vItemUnitArr.ResultSet;
      }
    } else {
      fAlertToast("FAILED", vItemUnitArr.Message);
      return [];
    }
  };

  const GetUnitRate = async (xB_Itmcd, xB_Unit) => {
    let vItemunitRateObj = {
      itemCd: xB_Itmcd,
      unit: xB_Unit,
      loc: vRdxSalesQuotationHead.A_Loc,
      type: vRdxSalesQuotationHead.A_Type,
      party: vRdxSalesQuotationHead.A_Party,
      date: moment(vRdxSalesQuotationHead.A_PostDt).format("MM/DD/YYYY"),
      curr: vRdxSalesQuotationHead.A_Curr,
    };
    const vItemUnitRate = await fExecuteAPI(
      "UNITRATE_GETROW",
      vItemunitRateObj
    );

    if (vItemUnitRate.Type === "SUCCESS") {
      return vItemUnitRate.ResultSet;
    } else {
      fAlertToast("FAILED", vItemUnitRate.Message);
    }
  };

  //API SALESGROUP
  const GetSalesGroupSearch = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs.Type == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast("FAILED", vSalesGroupSearchs.Message);
    }
  };

  //API SaveSIHead
  const fSaveHead = async (xSave, xDocStatus = "POST") => {
    const iStatus = xSave ? vRdxSalesQuotationHead.A_DocStat : xDocStatus; //xSave False means Post
    let vSaveSIHeadObj = {
      v_A_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
      v_A_VocNo: vRdxSalesQuotationHead.A_VocNo,
      v_A_VocDt: moment(vRdxSalesQuotationHead.A_PostDt).format("MM/DD/YYYY"),
      v_A_PostDt: moment(vRdxSalesQuotationHead.A_PostDt).format("MM/DD/YYYY"),
      v_A_RefDt: moment(vRdxSalesQuotationHead.A_RefDt).format("MM/DD/YYYY"),
      v_A_RefNo: vRdxSalesQuotationHead.A_RefNo,
      v_A_Party: vRdxSalesQuotationHead.A_Party,
      v_A_Curr: vRdxSalesQuotationHead.A_Curr,
      v_A_ExRate: vRdxSalesQuotationHead.A_ExRate,
      v_A_PayMode: vRdxSalesQuotationHead.A_PayMode,
      v_A_Type: vRdxSalesQuotationHead.A_Type,
      v_A_Br: "",
      v_A_Loc: vRdxSalesQuotationHead.A_Loc,
      v_A_Buyer: vRdxSalesQuotationHead.A_Buyer,
      v_A_Narr: vRdxSalesQuotationHead.A_Narr,
      v_A_CrAc: "",
      v_A_DrAc: "",
      v_A_DiscPerc: vRdxSalesQuotationHead.A_DiscPerc,
      v_A_Rounding: vRdxSalesQuotationHead.A_Rounding,
      v_A_DocStat: iStatus,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
      v_A_TaxGross: "N",
      v_A_Taxable: vRdxSalesQuotationHead.A_Taxable,
      v_A_CUSTFIELD1: "",
      v_A_CUSTFIELD2: "",
      v_A_CUSTFIELD3: vRdxSalesQuotationHead.A_CUSTFIELD3,
      v_A_CUSTFIELD4: "N",
      v_A_CUSTFIELD5: "",
      v_A_CUSTFIELD6: "N",
      v_A_CUSTFIELD7: "",
      v_A_CUSTFIELD8: "",
      v_A_CUSTFIELD9: "",
      v_A_CUSTFIELD10: "",

      LineItems: xSave
        ? [
            {
              v_B_Srno: sBufferObj.B_Srno,
              v_B_Itmcd: sBufferObj.B_Itmcd,
              v_B_Qty: sBufferObj.B_Qty,
              v_B_Unit: sBufferObj.B_Unit,
              v_B_BaseQty: sBufferObj.B_BaseQty,
              v_B_URateFc: sBufferObj.B_URateFc,
              v_B_URateLc: sBufferObj.B_URateLc,
              v_B_GrossAmt: sBufferObj.B_GrossAmt,
              v_B_LDiscPerc: sBufferObj.B_LDiscPerc,
              v_B_LDiscAmt: sBufferObj.B_LDiscAmt,

              v_B_FocFlag: sBufferObj.B_FocFlag,
              v_B_AprmtFlag: "",
              v_B_NetAmt: sBufferObj.B_NetAmt, //TaxableAmt
              v_B_LandVal: sBufferObj.B_NetAmt, //by sir
              v_B_BatchNo: "1 Year",
              v_B_URate_Fixed: 0,
              v_B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt, //Excise
              v_B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt, //net excise
              v_B_TaxPerc: 0,
              v_B_TaxAmt: 0,
              v_B_TaxPerc2: 0,
              v_B_TaxAmt2: 0,
              v_B_Ad_CessAmt: 0, //Add Cess Amt
              v_B_Ad_PCQty: 0,
              v_B_Ad_PCRate: 0,
              v_B_Ad_NetCessAmt: 0,
              v_TaxDept: "",
              v_TaxDept2: "",
              v_B_FOCAmt: sBufferObj.B_FocAmt,
              v_B_TDiscPerc: sBufferObj.B_TDiscPerc,
              v_B_TDiscAmt: sBufferObj.B_TDiscAmt,
            },
          ]
        : [],
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
    const vSaveSIHead = await inv05_SalesQuotation_Save_GETROW(FinalObj);

    if (vSaveSIHead?.status === 200) {
      let iVocNo = xSave
        ? vSaveSIHead?.data?.ResultSet?.DocNo
        : vRdxSalesQuotationHead.A_VocNo;
      if (vRdxSalesQuotationHead.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
            A_VocNo: iVocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Set_SalesQuotation_HeadObject_VocNo_Doc({
          A_VocNo: iVocNo,
          A_DocStat: iStatus,
        })
      );
      //approve bool type false
      if (!xSave) {
        fDisplay(vRdxSalesQuotationHead.A_VocTyp, iVocNo);
        fAlertToast("SUCCESS", "Successfully posted");
      } else {
        fNewDetail(
          iVocNo,
          vRdxSalesQuotationHead.A_Rounding,
          vRdxSalesQuotationHead.A_VocTyp,
          vRdxSalesQuotationHead.A_CUSTFIELD3
        );
      }
    } else {
      setErrorMsg((obj) => ({
        ...obj,
        [vSaveSIHead?.response?.data?.ResultSet?.field]:
          vSaveSIHead?.response?.data?.Status,
      }));
    }
  };

  //API GETSIHEAD_GETROW to gethead
  const fDisplay = async (xA_VocTyp, A_VocNo) => {
    let vSIHeadObj = {
      v_A_VocTyp: xA_VocTyp,
      v_A_VocNo: A_VocNo,
    };
    const vSIHead = await inv05_SalesQuotation_Display_GETROW(vSIHeadObj);
    if (vSIHead?.status === 200) {
      let iResp = vSIHead?.data?.ResultSet[0];
      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_VocTyp: iResp?.A_VocTyp,
          A_VocTypName: iResp?.VocName,
          A_VocNo: iResp?.A_VocNo,
          A_PostDt: iResp?.A_PostDt,
          A_RefDt: iResp?.A_RefDt,
          A_RefNo: iResp?.A_RefNo,
          A_Party: iResp?.A_Party,
          A_PartyName: iResp?.PartyName,
          A_Curr: iResp?.A_Curr,
          A_Currname: iResp?.CurrName,
          A_ExRate: iResp?.A_ExRate,
          A_PayMode: iResp?.A_PayMode,
          A_Type: iResp?.A_Type,
          A_Loc: iResp?.A_Loc,
          A_Buyer: iResp?.A_Buyer, ////SalesMan
          A_Narr: iResp?.A_Narr,
          A_DiscFlag: iResp?.A_DiscFlag,

          A_DiscPerc: !!iResp?.A_DiscPerc ? iResp?.A_DiscPerc : 0,
          A_Rounding: !!iResp?.A_Rounding ? iResp?.A_Rounding : 0,
          A_DocStat: iResp?.A_DocStat,
          A_CUSTFIELD3: iResp?.A_CUSTFIELD3,
          A_TaxGross: iResp?.A_TaxGross,
          A_Taxable: iResp?.A_Taxable,
        })
      );

      ItemsAliasListSearch(iResp?.A_Loc, sBufferObj.B_Itmcd);

      fNewDetail(
        iResp?.A_VocNo,
        iResp?.A_Rounding,
        iResp?.A_VocTyp,
        iResp?.A_CUSTFIELD3
      );
    } else {
      fAlertToast("FAILED", vSIHead.Message);
    }
  };

  //API GETSIDETAILS_GETROW
  const fLoad_Grid = async (
    xB_VocNo,
    xB_Srno,
    xRoundingValue = "",
    xVocTyp
  ) => {
    let iSIDetailObj = {
      v_VocTyp: !!xVocTyp ? xVocTyp : "",
      v_VocNo: !!xB_VocNo ? xB_VocNo : "",
      v_SrNo: xB_Srno,
    };

    const iSIDetail = await inv05_SalesQuotation_Load_GETROW(iSIDetailObj);

    if (iSIDetail?.status === 200) {
      setDetailGridData(iSIDetail?.data?.ResultSet);
      var iGrossAmt = 0,
        iTDiscAmt = 0,
        iLDiscAmt = 0,
        iFocAmt = 0,
        iExciseTaxNetAmt = 0,
        iTaxAmt = 0,
        iTaxAmt2 = 0,
        iAddCess = 0;
      for (let i = 0; i < iSIDetail?.data?.ResultSet?.length; i++) {
        iGrossAmt += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_GrossAmt);
        iTDiscAmt += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_TDiscAmt);
        iLDiscAmt += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_LDiscAmt);
        iFocAmt += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_FocAmt);
        iExciseTaxNetAmt += fcovertToNumber(
          iSIDetail?.data?.ResultSet[i]?.B_ExciseTaxNetAmt
        );
        iTaxAmt += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_TaxAmt);
        iTaxAmt2 += fcovertToNumber(iSIDetail?.data?.ResultSet[i]?.B_TaxAmt2);
        iAddCess += fcovertToNumber(
          iSIDetail?.data?.ResultSet[i]?.B_Ad_CessAmt
        );
      }

      let iLandVal =
        iGrossAmt -
        iTDiscAmt -
        iLDiscAmt -
        iFocAmt +
        iExciseTaxNetAmt +
        iTaxAmt +
        iTaxAmt2 +
        iAddCess +
        fcovertToNumber(xRoundingValue);

      console.log({
        A_GrossAmt: iGrossAmt.toFixed(2),
        A_TDiscAmt: iTDiscAmt.toFixed(2),
        A_LDiscAmt: iLDiscAmt.toFixed(2),
        A_FocAmt: iFocAmt.toFixed(2),
        A_NetExcise: iExciseTaxNetAmt.toFixed(2),
        A_Tax: iTaxAmt.toFixed(2),
        A_Tax2: iTaxAmt2.toFixed(2),
        A_AddCess: iAddCess.toFixed(2),
        A_LandVal: iLandVal.toFixed(2),
      });

      setFooterObj((obj) => ({
        ...obj,
        A_GrossAmt: iGrossAmt.toFixed(2),
        A_TDiscAmt: iTDiscAmt.toFixed(2),
        A_LDiscAmt: iLDiscAmt.toFixed(2),
        A_FocAmt: iFocAmt.toFixed(2),
        A_NetExcise: iExciseTaxNetAmt.toFixed(2),
        A_Tax: iTaxAmt.toFixed(2),
        A_Tax2: iTaxAmt2.toFixed(2),
        A_AddCess: iAddCess.toFixed(2),
        A_LandVal: iLandVal.toFixed(2),
      }));
    }
  };

  //DELETESIHEAD_GETROW
  const fDeleteHead = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      v_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
      v_VocNo: vRdxSalesQuotationHead.A_VocNo,
      v_SrNo: Srno,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
    };
    const vDeleteSIHead = await inv05_SalesQuotation_Delete_GETROW(
      vDeleteSIHeadObj
    );
    if (vDeleteSIHead?.status === 200) {
      if (Srno == 0) {
        // vocno,srno
        dispatch(
          Set_SalesQuotation_HeadObject_DocStatus({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxSalesQuotationHead.A_VocTyp,
          vRdxSalesQuotationHead.A_VocNo
        );
        fNewDetail(
          vRdxSalesQuotationHead.A_VocNo,
          vRdxSalesQuotationHead.A_Rounding,
          vRdxSalesQuotationHead.A_VocTyp,
          vRdxSalesQuotationHead.A_CUSTFIELD3
        );
        fAlertToast("SUCCESS", "Successfully Deleted");
      } else {
        fAlertToast("SUCCESS", "Successfully Deleted Line Item");
        fNewDetail(
          vRdxSalesQuotationHead.A_VocNo,
          "",
          vRdxSalesQuotationHead.A_VocTyp,
          vRdxSalesQuotationHead.A_CUSTFIELD3
        );
      }
    }
  };

  const fonRowClickGridObj = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
      B_VocNo: vRdxSalesQuotationHead.A_VocNo,
      B_Srno: item.row.B_Srno,
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      // B_PackQty: item.row?.B_PackQty,
      B_BaseQty: item.row.B_BaseQty,
      B_URateFc: item.row.B_URateFc,
      B_URateLc: item.row.B_URateLc,
      B_GrossAmt: item.row.B_GrossAmt,
      B_LDiscPerc: item.row.B_LDiscPerc,
      B_LDiscAmt: item.row.B_LDiscAmt,
      B_TDiscPerc: item.row.B_TDiscPerc,
      B_TDiscAmt: item.row.B_TDiscAmt,
      B_FocFlag: item.row.B_FocFlag,
      B_FocAmt: item.row.B_FocAmt,

      B_Rounding: !!item?.row?.B_Rounding ? item.row.B_Rounding : 0,
      B_LandVal: item.row.B_LandVal,
      B_URate_Fixed: item.row.B_URate_Fixed,
      B_ExciseTaxPerc: item.row.B_ExciseTaxPerc,
      B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,

      B_NetAmt: item.row.B_NetAmt,
      // Narration: item.row.Field8,
      // Itm_DefUnit: "",
      // Itm_SalUnit: "",
    }));

    let vUnitArr = await GetUnitArr(item.row.B_Itmcd);
    let vUnitvalue = vUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });

    if (!!vUnitvalue) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: vUnitvalue?.Unit,
        B_UnitName: vUnitvalue?.Name1,
        B_PackQty: vUnitvalue?.PackQty,
      }));
    }

    await ItemsAliasListSearch(vRdxSalesQuotationHead.A_Loc, item.row.B_Itmcd);

    let vCurrentSalesHistory = await GetSalesHistory(item.row.B_Itmcd);

    if (vCurrentSalesHistory.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
    GetItemNarration(item.row.B_Itmcd, vRdxSalesQuotationHead.A_Loc);
  };

  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (
      Number(sDiscPerModelObj.A_DiscPerc) != 0 &&
      Number(sDiscPerModelObj.A_TDiscAmt <= 0)
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage.",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc <= 0) &&
      Number(sDiscPerModelObj.A_TDiscAmt) != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(sDiscPerModelObj.A_DiscPerc > 100) ||
      Number(sDiscPerModelObj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  //API SALESHISTORY_GETROW
  const GetSalesHistory = async (xItmcd) => {
    let vSalesHistoryObj = {
      v_ItmCd: xItmcd,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vSalesHistory = await inv05_SalesQuotation_HistoryGrid_GETROW(
      vSalesHistoryObj
    );
    if (vSalesHistory?.status === 200) {
      let vSalesHistoryResp = vSalesHistory?.data?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
        // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
      }));
      setGridSalesHistoryRowData(vSalesHistoryResp);
      return vSalesHistoryResp;
    }
  };
  //API APPLYTDISCOUNT_GETROW
  const GetApplyTDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        v_B_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
        v_B_VocNo: vRdxSalesQuotationHead.A_VocNo,
        v_TDiscPerc: sDiscPerModelObj.A_DiscPerc,
      };
      const vApplyTDiscount = await inv05_SalesQuotation_Discount_GETROW(
        vApplyTDiscountObj
      );
      if (vApplyTDiscount?.status === 200) {
        dispatch(
          Set_SalesQuotation_HeadObject_Set({
            ...vRdxSalesQuotationHead,
            A_DiscPerc: sDiscPerModelObj.A_DiscPerc,
          })
        );
        fCloseDiscountPercentageModal();
        fNewDetail(
          vRdxSalesQuotationHead.A_VocNo,
          vRdxSalesQuotationHead.A_Rounding,
          vRdxSalesQuotationHead.A_VocTyp,
          vRdxSalesQuotationHead.A_CUSTFIELD3
        );
        setTimeout(() => {
          document?.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      }
    }
  };

  //API ITEMNARRATION_GETROW
  const GetItemNarration = async (xitmCd, xloc) => {
    let vItemNarrationObj = {
      itmCd: xitmCd,
      loc: xloc,
    };
    const vItemNarration = await fExecuteAPI(
      "ITEMNARRATION_GETROW",
      vItemNarrationObj
    );
    if (vItemNarration.Type === "SUCCESS") {
      let itemList = vItemNarration.ResultSet.map((obj) => {
        return obj.Name;
      });
      //bcoz itemlist returning "" in arr [0]
      if (itemList[0] != "") {
        setNarrArr(itemList);
      }
    } else if (
      vItemNarration.response.status == 400 ||
      vItemNarration.response.status == 500
    ) {
      fAlertToast("FAILED", vItemNarration.response.data.Status);
    }
  };
  let { A_VocTyp, A_VocNo } = vRdxSalesQuotationHead;
  //API WMSSI_ITEMSTOCK_GETROW // for viewing ERP & WMS
  const GetItemStock = useCallback(
    async (xItemCode, xSrno, xLoc, xUnit) => {
      let vItemStockObj = {
        itmCd: xItemCode.trim(),
        loc: xLoc,
        vocTyp: A_VocTyp,
        vocNo: A_VocNo,
        srNo: xSrno,
        unit: xUnit,
      };
      const vItemStock = await inv05_SalesQuotation_sopstockdetail_GETROW(
        vItemStockObj
      );
      if (
        !!vItemStock &&
        vItemStock?.status === 200 &&
        vItemStock?.data?.ResultSet.length > 0
      ) {
        setItemStock((obj) => ({
          ...obj,
          rpStock: vItemStock?.data?.ResultSet[0]?.rpStock,
          msp: vItemStock?.data?.ResultSet[0]?.msp,
          costpr: vItemStock?.data?.ResultSet[0]?.costpr,
        }));
      }
    },
    [A_VocTyp, A_VocNo]
  );

  //API TransTaxType_GETROW
  const GetTransTaxType = async (xLoc, xParty) => {
    let vTransTaxTypeObj = {
      loc: xLoc,
      party: xParty,
      taxtype: "OUT",
    };
    const vItemStock = await fExecuteAPI(
      "TransTaxType_GETROW",
      vTransTaxTypeObj
    );
    if (vItemStock.Type === "SUCCESS") {
      return vItemStock.ResultSet;
    } else {
      fAlertToast("FAILED", vItemStock.response.data.Status);
      return [];
    }
  };

  //API CHECKCUSTOMEROVERDUE_GETROW
  const GetCheckCustomerOverDue = async () => {
    let vCheckCustomerOverDueObj = {
      A_Party: vRdxSalesQuotationHead.A_Party,
      userGrp: vRdxuserInfo.UserGroupCode,
    };
    const vCheckCustomerOverDue = await fExecuteAPI(
      "CHECKCUSTOMEROVERDUE_GETROW",
      vCheckCustomerOverDueObj
    );
    if (vCheckCustomerOverDue.Type === "SUCCESS") {
      return vCheckCustomerOverDue.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vCheckCustomerOverDue.Message ||
          vCheckCustomerOverDue.response.data.Status ||
          vCheckCustomerOverDue?.response?.data?.message ||
          vCheckCustomerOverDue?.message
      );
    }
  };
  //API CHECKCRLIMIT_GETROW
  const GetCheckCRLimit = async () => {
    let vCheckCRLimitObj = {
      A_Party: vRdxSalesQuotationHead.A_Party,
      userGrp: vRdxuserInfo.UserGroupCode,
      landAmt: sFooterObj.A_LandVal,
      loc: vRdxSalesQuotationHead.A_Loc,
    };
    const vCheckCRLimit = await fExecuteAPI(
      "CHECKCRLIMIT_GETROW",
      vCheckCRLimitObj
    );
    if (vCheckCRLimit.Type === "SUCCESS") {
      return vCheckCRLimit.ResultSet;
    } else if (vCheckCRLimit.Type === "FAILED") {
      fAlertToast("FAILED", vCheckCRLimit?.Status);
    } else {
      fAlertToast("FAILED", vCheckCRLimit?.Message);
    }
  };

  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxSalesQuotationHead.A_VocTyp,
      vocNo: vRdxSalesQuotationHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", vTransAuditObj);
    if (vTransAudit.Type === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API GETITEMATTRIBUTES_GETROW
  const fValidateItemsAttributes = async () => {
    let vItemAttributesObj = {
      itmCd: sBufferObj?.B_Itmcd,
      loc: vRdxSalesQuotationHead?.A_Loc,
      taxType: vRdxSalesQuotationHead?.A_CUSTFIELD3,
      unit: sBufferObj?.B_Unit,
    };

    const vItemAttributes = await fExecuteAPI(
      "Lineitemsattributes_GETROW",
      vItemAttributesObj
    );

    if (
      vItemAttributes.Type === "SUCCESS" &&
      vItemAttributes.ResultSet.length > 0
    ) {
      let vGetItemAttributes = vItemAttributes.ResultSet[0];
      let iRes = true;

      if (vGetItemAttributes.Linking != "") {
        setErrorMsg((...obj) => ({
          ...obj,
          B_Itmcd: vGetItemAttributes.Linking,
        }));
        iRes = false;
      }

      if (vGetItemAttributes.ItmActive == "N") {
        setErrorMsg((...obj) => ({
          ...obj,
          B_ItmName: "Item is in-actived",
        }));
        iRes = false;
      }

      // if (vGetItemAttributes.Stock - sBufferObj.B_BaseQty < 0) {
      //     fAlertToast("FAILED", "Qty exceed than Available stock " + vGetItemAttributes.Stock.toFixed(2));
      //     iRes = false
      // }

      return { iRes, vGetItemAttributes };
    } else {
      fAlertToast("FAILED", vItemAttributes.Message);
    }
  };

  //defcustomersetting_GETROW
  const GetDefcustomersetting = async (xAcCd, xLoc) => {
    if (vRdxDBKernObj.SONAS_INVOICE?.Val === "Y") {
      let vdefcustomersettingObj = {
        accd: xAcCd,
        loc: xLoc,
      };
      const vdefcustomersetting = await fExecuteAPI(
        "defcustomersetting_GETROW",
        vdefcustomersettingObj
      );
      if (vdefcustomersetting.Type == "SUCCESS") {
        if (
          vdefcustomersetting.ResultSet.length > 0 &&
          !!vdefcustomersetting.ResultSet[0]?.SalesMan
        ) {
          dispatch(
            Set_SalesQuotation_HeadObject_SalesGroup_SalesMan({
              A_Buyer: !!vdefcustomersetting?.ResultSet[0]?.SalesMan
                ? vdefcustomersetting?.ResultSet[0]?.SalesMan
                : sSalesman[0]?.UId,
            })
          );
        }
      } else {
        fAlertToast(
          "FAILED",
          !!vdefcustomersetting.Message
            ? vdefcustomersetting.Message
            : "Error in default setting customer"
        );
      }
    }
  };

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: vRdxSalesQuotationHead.A_VocTyp,
      v_VocNo: vRdxSalesQuotationHead.A_VocNo,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
      v_Narr: sRevNarr,
      v_Loc: vRdxSalesQuotationHead.A_Loc,
      v_Party: vRdxSalesQuotationHead.A_Party,
      v_NetAmtPre: sFooterObj.A_LandVal,
    };
    const vRevereTransaction = await inv05_SalesQuotation_Reverse_GETROW(
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };

  const [sERPStockModal, setERPStockModal] = useState(false);
  const [sERPStockGridRow, setERPStockGridRow] = useState([]);
  const [sERPStockGridColumn, setERPStockGridColumn] = useState([
    {
      field: "SrNo",
      headerName: "Sr.No",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "DocNo",
      headerName: "Doc.No",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "Trans",
      headerName: "Trans",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 50,
      headerClassName: "grid-header-row",
    },
  ]);
  const fOpenERPStockModal = () => {
    GetERpStock();
    setERPStockModal(true);
  };
  const fCloseERPStockModal = (e) => {
    setERPStockModal(false);
    setERPStockGridRow([]);
  };
  //API DISPATCH_VARIANCE_ITEMS_GETROW
  const GetERpStock = async () => {
    let vERpStockObj = {
      ItmCd: sBufferObj.B_Itmcd,
      Loc: vRdxSalesQuotationHead.A_Loc,
      InvType: "",
      VocTyp: vRdxSalesQuotationHead.A_VocTyp,
      VocNo: vRdxSalesQuotationHead.A_VocNo,
      SrNo: sBufferObj.B_Srno,
      Unit: sBufferObj.B_Unit,
    };
    const vERpStock = await fExecuteAPI(
      "WMINV08_wmsErpStockDetail_GETROW",
      vERpStockObj
    );
    if (vERpStock?.Type?.toUpperCase() == "SUCCESS") {
      let GridID = vERpStock.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setERPStockGridRow(GridID);
    } else {
      fAlertToast("FAILED", vERpStock.response.data.message);
    }
  };
  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setToggleGrid(false);
    }
    if (e.key === "Enter") {
      let lastChild = document.getElementById("SalesQuotationContentID");
      let TagArr = !!lastChild ? lastChild.querySelectorAll(".col-4") : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";
      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1].getElementsByTagName("input")[0].name ==
            e.target.name &&
          document.getElementById("WMSDocStatID").innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                id: "EnterSave",
                label: "Yes",
                onClick: () => {
                  document.getElementById("SalesQuotationSave").click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
            onOpen: () => {
              setTimeout(() => {
                document?.getElementById("EnterSave")?.focus();
              }, 500);
            },
          });
        }
      }
    }
    if (e.key === "Escape") {
      setToggleGrid(false);
      setNarrationToggleDropdown(false);
      setCustomerToggleDropdown(false);
      setToggleDropdown(false);
    }
  }, []);

  //API ItemsAliasList_GETROW
  const ItemsAliasListSearch = async (xLoc, xItmCd) => {
    let ItemsAliasListSearchObj = {
      ItmCd: xItmCd,
      Loc: xLoc,
    };
    const vItemsAliasListSearchSearch = await fExecuteAPI(
      "ItemsAliasList_GETROW",
      ItemsAliasListSearchObj
    );
    if (vItemsAliasListSearchSearch?.Type == "SUCCESS") {
      // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
      let GridID = vItemsAliasListSearchSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setNarrationSearchGridData(GridID);
      setNarrationSearchGridFullData(GridID);
      return GridID;
    } else if (vItemsAliasListSearchSearch.Type == "FAILED") {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.Message);
      return [];
    } else if (
      vItemsAliasListSearchSearch.response.status == 500 ||
      vItemsAliasListSearchSearch.response.status == 400
    ) {
      fAlertToast("FAILED", vItemsAliasListSearchSearch.response.data.message);
      return [];
    } else {
      fAlertToast("FAILED", "Error in loading ItemsAliasListSearchSearch");
      return [];
    }
  };

  useEffect(() => {
    if (vRdxSalesQuotationHead.A_DocStat == "ENTER") {
      GetItemStock(
        sBufferObj.B_Itmcd,
        sBufferObj.B_Srno,
        vRdxSalesQuotationHead.A_Loc,
        sBufferObj.B_Unit
      );
    }
  }, [
    GetItemStock,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Srno,
    vRdxSalesQuotationHead.A_Loc,
    sBufferObj.B_Unit,
    vRdxSalesQuotationHead.A_DocStat,
  ]);

  const fOnload = async () => {
    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setDocLoading,
      setCurrency,
      setSalesman,
      setTaxType,
      setLocation,
      setAuditSelectArr
    );

    var CurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };

    const vLoc = iAttributeResp?.Loc;
    const vCurrency = iAttributeResp?.Currency;
    if (vCurrency.length > 0) {
      CurrencyArr = vCurrency[0];
    }
    //Grn Salesman select api
    var SalesManId = "";
    const vSalesman = iAttributeResp?.Salesman;
    if (vSalesman?.length > 0) {
      SalesManId = vSalesman[0].UId;
    }

    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxSalesQuotationHead.A_Loc == "" ||
        vRdxSalesQuotationHead.A_Loc === null ||
        vRdxSalesQuotationHead.A_Loc === undefined
        ? vLoc[0]?.UID
        : vRdxSalesQuotationHead?.A_Loc,
      vRdxSalesQuotationHead.A_Party
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    } else {
      vDefaultTaxType =
        iAttributeResp?.TaxType?.length > 0
          ? iAttributeResp?.TaxType[0].Uid
          : "";
    }

    let vDocLoadingObj = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    const vDocLoading = iAttributeResp?.DocLoading;
    if (vDocLoading.length > 0) {
      vDocLoadingObj = vDocLoading[0];
      fDefaultPayload(
        vRdxSalesQuotationHead.A_Curr == "" ||
          vRdxSalesQuotationHead.A_Curr === null ||
          vRdxSalesQuotationHead.A_Curr === undefined
          ? vDocLoading[0]?.Paymode
          : vRdxSalesQuotationHead.A_PayMode,
        dispatch,
        setPaymodeEnable
      );

      dispatch(
        Set_SalesQuotation_HeadObject_Set({
          ...vRdxSalesQuotationHead,
          A_VocTyp:
            vRdxSalesQuotationHead?.A_VocTyp == "" ||
            vRdxSalesQuotationHead?.A_VocTyp === null ||
            vRdxSalesQuotationHead?.A_VocTyp === undefined
              ? vDocLoadingObj.VocTyp
              : vRdxSalesQuotationHead.A_VocTyp,
          A_VocTypName:
            vRdxSalesQuotationHead?.A_VocTyp == "" ||
            vRdxSalesQuotationHead?.A_VocTyp === null ||
            vRdxSalesQuotationHead?.A_VocTyp === undefined
              ? vDocLoadingObj?.VocName
              : vRdxSalesQuotationHead?.A_VocTypName,
          A_Loc:
            vRdxSalesQuotationHead?.A_Loc == "" ||
            vRdxSalesQuotationHead?.A_Loc === null ||
            vRdxSalesQuotationHead?.A_Loc === undefined
              ? vLoc[0]?.UID
              : vRdxSalesQuotationHead?.A_Loc,
          A_Curr:
            vRdxSalesQuotationHead?.A_Curr == "" ||
            vRdxSalesQuotationHead?.A_Curr === null ||
            vRdxSalesQuotationHead?.A_Curr === undefined
              ? CurrencyArr?.Uid
              : vRdxSalesQuotationHead?.A_Curr,
          A_Currname:
            vRdxSalesQuotationHead?.A_Curr == "" ||
            vRdxSalesQuotationHead?.A_Curr === null ||
            vRdxSalesQuotationHead?.A_Curr === undefined
              ? CurrencyArr?.Name1
              : vRdxSalesQuotationHead?.A_Currname,
          A_ExRate:
            vRdxSalesQuotationHead?.A_Curr == "" ||
            vRdxSalesQuotationHead?.A_Curr === null ||
            vRdxSalesQuotationHead?.A_Curr === undefined
              ? CurrencyArr?.Rate
              : vRdxSalesQuotationHead?.A_ExRate,
          A_Type:
            vRdxSalesQuotationHead?.A_Curr == "" ||
            vRdxSalesQuotationHead?.A_Curr === null ||
            vRdxSalesQuotationHead?.A_Curr === undefined
              ? vRdxPricelevel[0]
              : vRdxSalesQuotationHead?.A_Type, //In this A_curr condition is checked bcoz on 1st  load A_type has def value
          A_Buyer:
            vRdxSalesQuotationHead?.A_Buyer == "" ||
            vRdxSalesQuotationHead?.A_Buyer === null ||
            vRdxSalesQuotationHead?.A_Buyer === undefined
              ? SalesManId
              : vRdxSalesQuotationHead?.A_Buyer,

          A_CUSTFIELD3:
            vRdxSalesQuotationHead?.A_Curr == "" ||
            vRdxSalesQuotationHead?.A_Curr === null ||
            vRdxSalesQuotationHead?.A_Curr === undefined
              ? vDefaultTaxType
              : vRdxSalesQuotationHead?.A_CUSTFIELD3,
        })
      );
      fLoad_Grid(
        vRdxSalesQuotationHead?.A_VocNo,
        0,
        0,
        vRdxSalesQuotationHead?.A_VocTyp == "" ||
          vRdxSalesQuotationHead?.A_VocTyp === null ||
          vRdxSalesQuotationHead?.A_VocTyp === undefined
          ? vDocLoadingObj?.VocTyp
          : vRdxSalesQuotationHead?.A_VocTyp
      );
      GetDefcustomersetting(
        vRdxSalesQuotationHead?.A_Party,
        vRdxSalesQuotationHead?.A_Loc == "" ||
          vRdxSalesQuotationHead?.A_Loc === null ||
          vRdxSalesQuotationHead?.A_Loc === undefined
          ? vLoc[0]?.UID
          : vRdxSalesQuotationHead?.A_Loc
      );
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxSalesQuotationHead?.A_Curr == "" ||
          vRdxSalesQuotationHead?.A_Curr === null ||
          vRdxSalesQuotationHead?.A_Curr === undefined
          ? CurrencyArr?.Rate
          : vRdxSalesQuotationHead?.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        vRdxSalesQuotationHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        0, //tax1%
        0, //tax%2
        0, //sBufferObj.B_Ad_PCRate,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_LandVal,
        B_TDiscPerc: vRdxSalesQuotationHead?.A_DiscPerc,
      }));
      ItemsAliasListSearch(
        vRdxSalesQuotationHead?.A_Loc == "" ||
          vRdxSalesQuotationHead?.A_Loc === null ||
          vRdxSalesQuotationHead?.A_Loc === undefined
          ? vLoc[0]?.UID
          : vRdxSalesQuotationHead?.A_Loc,
        sBufferObj?.B_Itmcd
      );
    } else {
      fAlertToast("FAILED", vDocLoading.Message);
    }
    GetItemNarration(
      sBufferObj?.B_Itmcd,
      vRdxSalesQuotationHead?.A_Loc == "" ||
        vRdxSalesQuotationHead?.A_Loc === null ||
        vRdxSalesQuotationHead?.A_Loc === undefined
        ? vLoc[0]?.UID
        : vRdxSalesQuotationHead?.A_Loc
    );
  };

  useEffect(() => {
    fOnload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxSalesQuotationHead.A_DocStat,
      vRdxSalesQuotationHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [
    vRdxSalesQuotationHead.A_DocStat,
    vRdxSalesQuotationHead.A_VocTyp,
    sObjectRights,
  ]);

  useEffect(() => {
    if (
      vRdxSalesQuotationHead.A_DocStat !== "ENTER" ||
      vRdxSalesQuotationHead.A_Loc === null ||
      vRdxSalesQuotationHead.A_Loc === undefined ||
      vRdxSalesQuotationHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxSalesQuotationHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxSalesQuotationHead.A_Loc,
    vRdxSalesQuotationHead.A_DocStat,
  ]);

  useEffect(() => {
    RefNoFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);
  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "P";
      FShortCutKey(
        e,
        "SalesQuotationNew",
        "SalesQuotationSave",
        "SalesQuotationApprove",
        "SalesQuotationSearch",
        "SalesQuotationDelete",
        "SalesQuotationAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);
  // if ONE TOGGLE FUNCTION OPEN THEN OTHER TOGGLE WILL CLOSE

  useEffect(() => {
    if (ToggleDropdown === true) {
      setNarrationToggleDropdown(false);
      setCustomerToggleDropdown(false);
    }
  }, [ToggleDropdown]);

  useEffect(() => {
    if (sCustomerToggleDropdown === true) {
      setToggleDropdown(false);
      setNarrationToggleDropdown(false);
    }
  }, [sCustomerToggleDropdown]);

  useEffect(() => {
    if (sNarrationToggleDropdown === true) {
      setCustomerToggleDropdown(false);
      setToggleDropdown(false);
    }
  }, [sNarrationToggleDropdown]);

  useEffect(() => {
    GetOSAmount(
      vRdxSalesQuotationHead.A_Loc,
      vRdxSalesQuotationHead.A_Party,
      setOsAmount
    );
  }, [vRdxSalesQuotationHead.A_Loc, vRdxSalesQuotationHead.A_Party]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (ToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sCustomerToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setCustomerToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sCustomerToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sNarrationToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setNarrationToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sNarrationToggleDropdown]);

  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    // { field: "id", headerName: "ID", width: 70, hide: true },
    {
      field: "B_Srno",
      headerName: "Sr.No",
      width: 50,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Itmcd",
      headerName: "Item Code",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 300,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateFc",
      headerName: "Unit Rate",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_GrossAmt",
      headerName: "Gross.Amt",
      width: 90,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscPerc",
      headerName: "L Disc %",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscAmt",
      headerName: "L Disc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_FocAmt",
      headerName: "Foc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_NetAmt",
      headerName: "Net.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxNetAmt",
      headerName: "B_ExciseTaxNetAmt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_TaxAmt",
      headerName: "B_TaxAmt1",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxPerc",
      headerName: "B_ExciseTaxPerc",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxAmt",
      headerName: "B_ExciseTaxAmt",
      width: 150,
      headerClassName: "grid-header-row",
    },

    {
      field: "B_TaxDept",
      headerName: "B_TaxDept",
      width: 150,
      headerClassName: "grid-header-row",
    },

    {
      field: "B_Unit",
      headerName: "B_Unit",
      width: 100,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_BaseQty",
      headerName: "B_BaseQty",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateLc",
      headerName: "B_URateLc",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },

    { field: "B_TDiscPerc", headerName: "B_TDiscPerc", width: 90, hide: true },
    { field: "B_TDiscAmt", headerName: "B_TDiscAmt", width: 90, hide: true },
    { field: "B_FocFlag", headerName: "B_FocFlag", width: 90, hide: true },
    { field: "B_TaxPerc", headerName: "B_TaxPerc", width: 90, hide: true },
    { field: "B_Rounding", headerName: "B_Rounding", width: 90, hide: true },
    { field: "B_LandVal", headerName: "B_LandVal", width: 90, hide: true },
    {
      field: "B_URate_Fixed",
      headerName: "B_URate_Fixed",
      width: 90,
      hide: true,
    },
    { field: "B_TaxDept2", headerName: "B_TaxDept2", width: 90, hide: true },
    { field: "B_TaxPerc2", headerName: "B_TaxPerc2", width: 90, hide: true },
    { field: "B_TaxAmt2", headerName: "B_TaxAmt2", width: 90, hide: true },

    { field: "Field8", headerName: "Field8", width: 90, hide: true },
  ]);
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "PartyName", headerName: "Vendor", width: 250 },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "A_NetAmt", headerName: "NetAmt", width: 90 },
    { field: "SalesGroup", headerName: "Sales Group", width: 130 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_VocTyp", headerName: "A_VocTyp", width: 90, hide: true },
  ]);

  const [GridDataColumnsVendorSearch, setGridDataColumnsVendorSearch] =
    useState([
      { field: "id", headerName: "id", hide: true },
      { field: "AcCd", headerName: "Code" },
      { field: "Name1", headerName: "Name", width: 350 },
    ]);

  //Item Search
  const [xcolumnsDropdownSearch, setxcolumnsDropdownSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "Item Code", width: 100 },
    { field: "Name2", headerName: "Name", width: 450 },
    { field: "Barcode", headerName: "Barcode", width: 220 },
  ]);
  //Customer Search
  const [columnsCustomerDropdownSearch, setcolumnsCustomerDropdownSearch] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "AcCd", headerName: "Code", width: 90 },
      { field: "Name2", headerName: "Name2", width: 450 },
      { field: "Name1", headerName: "Name1", width: 450 },
    ]);
  //Narration Search
  const [columnsNarrationDropdownSearch, setcolumnsNarrationDropdownSearch] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "Code", headerName: "Code", width: 80, hide: true },
      { field: "Name", headerName: "Name1", width: 220 },
    ]);
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);

  const [GridDataSalesHistoryColumns, setGridDataSalesHistoryColumns] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "Location", headerName: "Location", width: 130 },
      {
        field: "StkQty",
        headerName: "StkQty",
        width: 130,
      },
      { field: "PRQty", headerName: "PRQty", width: 90 },
      { field: "SOQty", headerName: "SOQty", width: 90 },
      { field: "DOQty", headerName: "DOQty", width: 90 },
      { field: "SIQty", headerName: "SIQty", width: 90 },
      { field: "TRFQty", headerName: "TRFQty", width: 90 },
      { field: "ADJQty", headerName: "ADJQty", width: 90 },
      { field: "Reversed", headerName: "Reversed", width: 90 },
      { field: "AvlQty", headerName: "AvlQty", width: 90 },
      { field: "Loc", headerName: "Loc", width: 90 },
    ]);

  const [
    xGCSearchBtn_Columns_DropdownSearch,
    setxGCSearchBtn_Columns_DropdownSearch,
  ] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name2", headerName: "Name2", width: 450 },
    // { field: "Name1", headerName: "Name1", width: 220 },
  ]);
  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "INV06B001WB",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "WMS_SALES_INVOICE_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataColumnsVendorSearch,
      "WMS_SALES_INVOICE_VENDOR",
      GridDataColumnsVendorSearch
    );

    GetGitterColumns(
      setxcolumnsDropdownSearch,
      "WMS_SALES_INVOICE_ITEM_SEARCH",
      xcolumnsDropdownSearch
    );
    GetGitterColumns(
      setcolumnsCustomerDropdownSearch,
      "WMS_SALES_INVOICE_CUST",
      columnsCustomerDropdownSearch
    );
    GetGitterColumns(
      setcolumnsNarrationDropdownSearch,
      "WMS_SALES_INVOICE_NARR",
      columnsNarrationDropdownSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataSalesHistoryColumns,
      "STKQRYWB",
      GridDataSalesHistoryColumns
    );
    GetGitterColumns(
      setxGCSearchBtn_Columns_DropdownSearch,
      "WMS_SALES_INVOICE_GCSearchBtn",
      xGCSearchBtn_Columns_DropdownSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxSalesQuotationHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={
          DisableApproveFlag()
            ? true
            : vRdxSalesQuotationHead.A_DocStat != "ENTER"
            ? true
            : false
        }
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          DisableApproveFlag()
            ? true
            : vRdxSalesQuotationHead.A_DocStat == "ENTER" ||
              vRdxSalesQuotationHead.A_DocStat == "DRAFT"
            ? false
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "38px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-sales-invoice ">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"SalesQuotationNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"SalesQuotationSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxSalesQuotationHead.A_DocStat != "ENTER"
                          ? true
                          : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxSalesQuotationHead.A_DocStat == "ENTER" ||
                            vRdxSalesQuotationHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"SalesQuotationSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxSalesQuotationHead.A_DocStat == "ENTER" &&
                      sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="SalesQuotationDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={4}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="SalesQuotationPrint"
                      onClick={(e) => {
                        fPrint("P");
                      }}
                    >
                      Sales Quotation AL QUOZ
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("DOC");
                      }}
                    >
                      Document
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WI");
                      }}
                    >
                      Sales Quotation AL QUOZ Without Image
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("GP");
                      }}
                    >
                      Sales Quotation GP Copy
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("FC");
                      }}
                    >
                      E-Mail
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Without Disc"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WD");
                      }}
                    >
                      With Image
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WIWD");
                      }}
                    >
                      Without Image
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="SalesQuotationAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      fOpenERPStockModal={fOpenERPStockModal}
                      sTax={sTaxTaxType}
                      xItemStock={sItemStock}
                      xPaymodeEnable={sPaymodeEnable}
                      xOsAmount={sOsAmount}
                      vRdxSalesQuotationHead={vRdxSalesQuotationHead}
                      sLocation={sLocation}
                      DocLoading={sDocLoading}
                      currency={sCurrency}
                      selecType={vRdxPricelevel}
                      sPayModeArr={sPayModeArr}
                      fOpenHeadCustomerSearchModalKey={
                        fOpenHeadCustomerSearchModalKey
                      }
                      fOnChangeSelectDocType={fOnChangeSelectDocType}
                      fOnChangeSelectCurr={fOnChangeSelectCurr}
                      fOnChangeInputDate={fOnChangeInputDate}
                      fOnChangeInputDateRefDate={fOnChangeInputDateRefDate}
                      fonChangeInput={fonChangeInput}
                      fonChangeInputTaxType={fonChangeInputTaxType}
                      fonChangeInputPayMode={fonChangeInputPayMode}
                      fonChangeInputTaxable={fonChangeInputTaxable}
                      fonChangeInputLocation={fonChangeInputLocation}
                      fonChangeInputCustomer={fonChangeInputCustomer}
                      // sInstTypeArr={sInstTypeArr}
                      sErrorMsg={sErrorMsg}
                      sDetailGridData={sDetailGridData}
                      sToggleGrid={sToggleGrid}
                      GridDataSalesHistoryColumns={GridDataSalesHistoryColumns}
                      sGridSalesHistoryRowData={sGridSalesHistoryRowData}
                      vMediaQuery={vMediaQuery}
                      xcolumnsDropdownSearch={columnsCustomerDropdownSearch}
                      xrowDropdownSearch={sCustSearchGridData}
                      xOnCellKeyDown={(newSelectionModel, e) => {
                        if (e.key === "Enter") {
                          fRowClick(newSelectionModel);
                        }
                      }}
                      xOnRowClick={fRowClick}
                      xToggleDropdown={sCustomerToggleDropdown}
                      xData={sCustomerSearchData}
                      xOnChange={fOnChangeCustomer}
                      xDropdownObj={sCustomerSearchDropdownObj}
                      xOnKeyUp={fOnKeyUpCustomer}
                      xhandleClick={fOpenHeadCustomerSearchModalKey}
                      inputReference={RefNoFocusOnLoad}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        fGrossAmt={fGrossAmt}
                        bufferObj={sBufferObj}
                        fonClickInputFocus={fContent_Focus}
                        fonClickInputBlur={fContent_Blur}
                        fonChangeInputQty={fonChangeInputQty}
                        fonChangeInputItemName={fonChangeInputItemName}
                        fonChangeInputUnit={fonChangeInputUnit}
                        fonChangeInputUnitRateFC={fonChangeInputUnitRateFC}
                        fUnitRateFCSave_onKeyUp={fUnitRateFCSave_onKeyUp}
                        fonChangeInputLDisc={fonChangeInputLDisc}
                        fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                        fOpenContentItemSearchModalKey={
                          fOpenContentItemSearchModalKey
                        }
                        fonChangeCheckBoxFoc={fonChangeCheckBoxFoc}
                        fonChangeInputExcise={fonChangeInputExcise}
                        fonChangeInputNarration={fonChangeInputNarration}
                        fonChangeInputSupervisorAmtSc={
                          fonChangeInputSupervisorAmtSc
                        }
                        fonChangeInputOtherAmtSc={fonChangeInputOtherAmtSc}
                        taxDept1={vRdxGRNtax1}
                        taxDept2={vRdxGRNtax2}
                        ItemUnit={sItemUnit}
                        sErrorMsg={sErrorMsg}
                        xNarrArr={sNarrArr}
                        vRdxSalesQuotationHead={vRdxSalesQuotationHead}
                        xItemStock={sItemStock}
                        //toggle item
                        xcolumnsDropdownSearch={xcolumnsDropdownSearch}
                        xrowDropdownSearch={sSearchGridData}
                        xOnCellKeyDown={(newSelectionModel, e) => {
                          if (e.key === "Enter") {
                            fOnRowClick(newSelectionModel);
                          }
                        }}
                        xOnRowClick={fOnRowClick}
                        xToggleDropdown={ToggleDropdown}
                        xData={sItemSearchData}
                        xOnChange={fOnChangeItem}
                        xDropdownObj={sItemSearchDropdownObj}
                        xOnKeyUp={fOnKeyUpItem}
                        xhandleClick={fOpenContentItemSearchModalKey}
                        xMediaQuery={vMediaQuery}
                        //togggle narration
                        xNarrationToggleDropdown={sNarrationToggleDropdown}
                        xrowDropdownNarrationSearch={sNarrationSearchGridData}
                        xcolumnsDropdownNarrationSearch={
                          columnsNarrationDropdownSearch
                        }
                        xOnCellKeyNarrationDown={(newSelectionModel, e) => {
                          if (e.key === "Enter") {
                            OnRowNarrationClick(newSelectionModel);
                          }
                        }}
                        xOnRowNarrationClick={OnRowNarrationClick}
                        fNarrationKeyEnter={fNarrationKeyEnter}
                        fFocusShowSalesHistoryGrid={fFocusShowSalesHistoryGrid}
                        xinputRef={ClickNewFocsItem}
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={(item) => {
                            fonRowClickGridObj(item);
                          }}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxSalesQuotationHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div
                        style={{
                          height: vMediaQuery ? "70vh" : "30vh",
                          width: "100%",
                        }}
                      >
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          getRowId={(row) => row.B_Srno}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fonRowClickGridObj}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <Footer
                      Salesman={sSalesman}
                      sFooterObj={sFooterObj}
                      fonChangeInputDiscount={fonChangeInputDiscount}
                      fonChangeRounding={fFooter_Rounding_OnChange}
                      fOpenDiscountPercentageModal={
                        fOpenDiscountPercentageModal
                      }
                      fonClickInputFocusRounding={fFooter_Rounding_Focus}
                      fonClickInputBlurRounding={fFooter_Rounding_Blur}
                      sErrorMsg={sErrorMsg}
                      vRdxSalesQuotationHead={vRdxSalesQuotationHead}
                      fonChangeSelectSalesMan={fonChangeSelectSalesMan}
                      fonClickInputBlurDiscount={fonClickInputBlurDiscount}
                      fonClickInputFocusDiscount={fonClickInputFocusDiscount}
                      fonChangeInputFooter={fonChangeInputFooter}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "69vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.B_Srno}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fonRowClickGridObj}
                hideFooter={sDetailGridData.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-2">
            <Footer
              Salesman={sSalesman}
              sFooterObj={sFooterObj}
              fonChangeInputDiscount={fonChangeInputDiscount}
              fonChangeRounding={fFooter_Rounding_OnChange}
              fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
              fonClickInputFocusRounding={fFooter_Rounding_Focus}
              fonClickInputBlurRounding={fFooter_Rounding_Blur}
              sErrorMsg={sErrorMsg}
              vRdxSalesQuotationHead={vRdxSalesQuotationHead}
              fonChangeSelectSalesMan={fonChangeSelectSalesMan}
              fonClickInputBlurDiscount={fonClickInputBlurDiscount}
              fonClickInputFocusDiscount={fonClickInputFocusDiscount}
              fonChangeInputFooter={fonChangeInputFooter}
            />
          </div>
        </Box>
      </Modal>

      <GCSearcgSalesQuotation
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sLocation}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangePartyModal={fonChangePartyModal}
        fonChangeLocModal={fonChangeLocModal}
        fonChangeRefNoModal={fonChangeRefNoModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={(newSelectionModel, e) => {
          if (e.key === "Enter") {
            fTrans_Search_Grid_RowClick(newSelectionModel);
          }
        }}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Sales Quotation - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
        xSalesGroupVal={sSearchModalObj.SalesGroup}
        xPartyVal={sSearchModalObj.Party}
        xPartyNameVal={sSearchModalObj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={(newSelectionModel, e) => {
          if (e.key === "Enter") {
            fGCSearchBtn_OnRowClick(newSelectionModel);
          }
        }}
      />
      <GCDiscountPercentage
        sDiscountPercentageModal={sDiscountPercentageModal}
        fCloseDiscountPercentageModal={fCloseDiscountPercentageModal}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={sDiscPerModelObj.A_TDiscAmt}
        xTDiscPer={sDiscPerModelObj.A_DiscPerc}
        fonChangeInputDiscountModal={fonChangeInputDiscountModal}
        fOnChangeTDiscAmtModal={fOnChangeTDiscAmtModal}
        GetApplyTDiscount={GetApplyTDiscount}
        xErrorMsg_DiscPerc={sErrorMsgDiscountModal.A_DiscPerc}
        xErrorMsg_TDiscAmt={sErrorMsgDiscountModal.A_TDiscAmt}
        xRdx_DocStatus={vRdxSalesQuotationHead.A_DocStat !== "ENTER"}
      />

      {/* Reverse Narration  */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={fCloseReverseTransactionModal}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={fReverse}
      />
      {/* GCAudit Modal */}
      <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={
          vRdxSalesQuotationHead.A_VocTypName +
          "-" +
          vRdxSalesQuotationHead.A_VocNo
        }
      />

      <Modal
        open={sERPStockModal}
        onClose={fCloseERPStockModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-ERP-Stock">
          <div>
            <GCTitleSticky
              title={"Stock Detail"}
              onClose={fCloseERPStockModal}
            />

            <div className="py-3">
              <Box
                style={{ height: vMediaQuery ? "40vh" : "40vh", width: "99%" }}
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sERPStockGridRow}
                  columns={sERPStockGridColumn}
                  hideFooter={sERPStockGridRow.length < 100}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box>
            </div>
          </div>
        </Box>
      </Modal>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxSalesQuotationHead.A_VocTyp}
        xLabelVocName={vRdxSalesQuotationHead.A_VocTypName}
        xLabelVocNo={vRdxSalesQuotationHead.A_VocNo}
      />
      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxSalesQuotationHead.A_VocTyp}
        xLabelVocName={vRdxSalesQuotationHead.A_VocTypName}
        xLabelVocNo={vRdxSalesQuotationHead.A_VocNo}
      />
    </div>
  );
}
